export const DATALAYER_EVENTS = Object.freeze({
  Landed: "Landed",
  CustomerInfo_Yes: "CustomerInfo_Yes",
  NRI_Yes: "NRI_Yes",
  NRI_No: "NRI_No",
  NPS_Yes: "NPS_Yes",
  NPS_No: "NPS_No",
  NRIInfo_Selected: "NRIInfo_Selected",
  NRIInfo_PopupOpen: "NRIInfo_PopupOpen",
  NRIInfo_PopupClose: "NRIInfo_PopupClose",
  NRIInfo_OkGotIt: "NRIInfo_OkGotIt",
  NRICorner_Selected: "NRICorner_Selected",
  NRICorner_PopupOpen: "NRICorner_PopupOpen",
  AppointSchedule_Selected: "AppointSchedule_Selected",
  AppointSchedule_PopupOpen: "AppointSchedule_PopupOpen",
  AppointSchedule_PopupClose: "AppointSchedule_PopupClose",
  AppointSchedule_BookCall: "AppointSchedule_BookCall",
  "AppointSchedule_BookCall_Skip&Conti": "AppointSchedule_BookCall_Skip&Conti",
  AppointSchedule_BookCall_Skip_Conti: "AppointSchedule_BookCall_Skip_Conti",
  AppointSchedule_Clicked: "AppointSchedule_Clicked",
  AppointSchedule_Success_PopupOpen: "AppointSchedule_Success_PopupOpen",
  AppointSchedule_Success_PopupClose: "AppointSchedule_Success_PopupClose",
  AppointReSchedule_Clicked: "AppointReSchedule_Clicked",
  AppointSchedule_Successfully: "AppointSchedule_Successfully",
  CriticalillnessClaim_Selected: "CriticalillnessClaim_Selected",
  ClaimsCorner_Criticalillnes_ViewDoc: "ClaimsCorner_Criticalillnes_ViewDoc",
  DeathClaim_Selected: "DeathClaim_Selected",
  ClaimsCorner_DeathClaim_ViewDoc: "ClaimsCorner_DeathClaim_ViewDoc",
  TalktoExpert_Selected: "TalktoExpert_Selected",
  TalktoExpert_PopupOpen: "TalktoExpert_PopupOpen",
  TalkToExpert_PopupClose: "TalkToExpert_PopupClose",
  TalkToExpert_OkGotIt: "TalkToExpert_OkGotIt",
  TalktoExpert_BookCall: "TalktoExpert_BookCall",
  TalktoExpert_RescheduleCall: "TalktoExpert_RescheduleCall",
  TalktoExpert_CancelCall: "TalktoExpert_CancelCall",
  PlanBenefit_Selected: "PlanBenefit_Selected",
  PlanBenefits_Close: "PlanBenefits_Close",
  PlanBenefits_CheckPremium: "PlanBenefits_CheckPremium",
  PlanBenefits_CalculateReturns: "PlanBenefits_CalculateReturns",

  PlanBenefits_PopupOpen: "PlanBenefits_PopupOpen",
  PlanBenefits_PopupClose: "PlanBenefits_PopupClose",
  BuyingFor: "BuyingFor",

  MobileNo_Selected: "MobileNo_Selected",
  EmailId_Selected: "EmailId_Selected",
  DOB_Selected: "DOB_Selected",
  Gender_Selected: "Gender_Selected",
  Income_Selected: "Income_Selected",
  Education_Selected: "Education_Selected",
  EducationQualification_Selected: "EducationQualification_Selected",

  _Overview: "_Overview",

  Pincode_Selected: "Pincode_Selected",
  City_Selected: "City_Selected",
  AnnualIncome_Selected: "AnnualIncome_Selected",
  Tobacco_Selected: "Tobacco_Selected",
  Marriage_Selected: "Marriage_Selected",
  Occupation_Selected: "Occupation_Selected",
  GroupEmployeeDiscount_LinkClicked: "GroupEmployeeDiscount_LinkClicked",
  SkipPersonalDetails_ClickHere: "SkipPersonalDetails_ClickHere",
  ProductAssessment_TCAccepted: "ProductAssessment_T&CAccepted",
  LeadSubmitted: "LeadSubmitted",
  LeadSubmitted_two: "LeadSubmitted_two",
  LeadSubmitted_MobileNumber: "LeadSubmitted_MobileNumber",
  GetQuote_EmailIDSubmitted: "GetQuote_EmailIDSubmitted",
  GetQuote_SkipPersonalDetails: "GetQuote_SkipPersonalDetails",
  QuickGuide_Question: "QuickGuide_Question",
  QuickGuide_Next: "QuickGuide_Next",
  QuickGuide_Previous: "QuickGuide_Previous",
  QuickGuide_CheckPremium: "QuickGuide_CheckPremium",
  QuickGuide_PopupOpen: "QuickGuide_PopupOpen",
  QuickGuide_PopupClose: "QuickGuide_PopupClose",
  Disclaimer_CheckPremium: "Disclaimer_CheckPremium",
  float_CheckPremium: "CheckPremium_Floatting",
  Disclaimer_Selected: "Disclaimer_Selected",
  Illustration1_Selected: "Illustration1_Selected",
  Illustration2_Selected: "Illustration2_Selected",
  Illustration1_CheckPremium: "Illustration1_CheckPremium",
  Illustration2_CheckPremium: "Illustration2_CheckPremium",
  FAQ_Selected: "FAQ_Selected",
  FAQ_Helpful: "FAQ_Helpful",
  FAQ_NotHelpful: "FAQ_NotHelpful",
  FAQ_SubmitFeedback: "FAQ_SubmitFeedback",
  FAQ_Search: "FAQ_Search",
  FAQ_Clear: "FAQ_Clear",
  FAQ_TermInsurance: "FAQ_TermInsurance",
  FAQ_SmartExitOption: "FAQ_ZeroCostTerm",
  FAQ_PayoutMethods: "FAQ_PayoutMethods",
  FAQ_Nominee: "FAQ_Nominee",
  FAQ_ApplicationForm: "FAQ_ApplicationForm",
  FAQ_MWPAct: "FAQ_MWPAct",
  FAQ_Smokers: "FAQ_Smokers",
  FAQ_OptionalBenefits: "FAQ_OptionalBenefits",
  FAQ_PremiumPayment: "FAQ_PremiumPayment",
  FAQ_PremiumRefundOption: "FAQ_PremiumRefundOption",
  FAQ_NRI: "FAQ_NRI",
  FAQ_3LInstantClaim: "FAQ_3LInstantClaim",
  FAQ_OptionalRiders: "FAQ_OptionalRiders",
  FAQ_PolicyRelated: "FAQ_PolicyRelated",
  FAQ_Tax: "FAQ_Tax",
  FAQ_ForWomen: "FAQ_ForWomen",
  FAQ_Claims: "FAQ_Claims",
  FAQ_LimitedPay: "FAQ_LimitedPay",
  PolicyCharges_Click: "PolicyCharges_Click",
  PolicyCharges_PopupOpen: "PolicyCharges_PopupOpen",
  PolicyCharges_PopupClose: "PolicyCharges_PopupClose",
  CheckmyGrowth_PopupOpen: "CheckmyGrowth_PopupOpen",
  CheckmyGrowth_PopupClose: "CheckmyGrowth_PopupClose",

  PopupClose: "PopupClose",
  CheckmyGrowth_RecomendedPlanOK: "CheckmyGrowth_RecomendedPlanOK",
  FAQ_PensionPlan: "FAQ_PensionPlan",
  FAQ_NPS: "FAQ_NPS",
  FAQ_PlanOptions: "FAQ_PlanOptions",
  FAQ_Benefit: "FAQ_Benefit",
  FAQ_Feature: "FAQ_Feature",

  DownloadBrochure: "DownloadBrochure",
  OnlineBenefits_Selected: "OnlineBenefits_Selected",
  OnlineBenefits_PopupOpen: "OnlineBenefits_PopupOpen",
  OnlineBenefits_OkGotIt: "OnlineBenefits_OkGotIt",
  "CTA_4%Selected": "CTA_4%Selected",
  "CTA_8%Selected": "CTA_8%Selected",
  OnlineBenefits_PopupClose: "OnlineBenefits_PopupClose",
  PlanBenefits_ViewAll: "PlanBenefits_ViewAll",
  ExploreMore_Selected: "ExploreMore_Selected",
  ExploreMore_PopupOpen: "ExploreMore_PopupOpen",
  ExploreMore_PopupClose: "ExploreMore_PopupClose",
  ExploreMore_KeyResons_Selected: "ExploreMore_KeyResons_Selected",
  ExploreMore_PlanChildFuture_Selected: "ExploreMore_PlanChildFuture_Selected",
  ExploreMore_PlanForChild_Selected: "ExploreMore_PlanForChild_Selected",
  BenefitPlan_Selected: "BenefitPlan_Selected",
  PlanRecommended_OptionSelected: "PlanRecommended_OptionSelected",
  PlanOption_ViewAll: "PlanOption_ViewAll",
  PlanOption_Hide: "PlanOption_Hide",

  QuickLinks_Download: "QuickLinks_Download",
  QuickLinks_Checknow: "QuickLinks_Checknow",
  PlanWorks_HPPBClick: "PlanWorks_HPPBClick",
  CalculateIncome_Clicked: "CalculateIncome_Clicked",
  IncomeDate: "IncomeDate",
  Overview: "Overview",

  InvestmentAmount: "InvestmentAmount",
  InvestmentFrequency: "InvestmentFrequency",
  InvestmentPayFor: "InvestmentPayFor",
  RecieveAnnuityAfter: "RecieveAnnuityAfter",
  AnnuityFrequency: "AnnuityFrequency",
  ebiCheck: "ebiCheck",

  JointLifePopupOpen: "JointLifePopupOpen",
  JointLifePopupClose: "JointLifePopupClose",
  ViewMoreAnnuityOption: "ViewMoreAnnuityOption",
  ShowLessAnnuityOption: "ShowLessAnnuityOption",
  TalkToExpert_ConnectNow: "TalkToExpert_ConnectNow",
  TalkToExpert_Continue: "TalkToExpert_Continue",
  CalculateIncome_Selected: "CalculateIncome_Selected",
  PrimaryFactor_OptionSelected: "PrimaryFactor_OptionSelected",

  KnowMore_Clicked: "KnowMore_Clicked",
  KnowMore_Selected: "KnowMore_Selected",
  KnowMore_PopupOpen: "KnowMore_PopupOpen",
  KnowMore_PopupClose: "KnowMore_PopupClose",
  CheckEligibility_Clicked: "CheckEligibility_Clicked",
  CheckEligibility_PopupOpen: "CheckEligibility_PopupOpen",
  CheckEligibility_PopupClose: "CheckEligibility_PopupClose",
  CheckEligibility_Okay: "CheckEligibility_Okay",
  PlanOption_Videoclicked: "PlanOption_Videoclicked",
  PlanOption_VideoClosed: "PlanOption_VideoClosed",
  RetirementPlanner_Download: "RetirementPlanner_Download",
  Pension_Assistance_Corner_Download: "Pension_Assistance_Corner_Download",
  KeyFeatures_Next: "KeyFeatures_Next",
  KeyFeatures_Previous: "KeyFeatures_Previous",
  Retirement_Calculator: "Retirement_Calculator",
  Pension_Assistance_Corner: "Pension_Assistance_Corner",

  New_Fund_Launch_PopupOpen: "New_Fund_Launch_PopupOpen",
  New_Fund_Launch_PopupClose: "New_Fund_Launch_PopupClose",

  PlanOption_LearnMore: "PlanOption_LearnMore",
  Illustration_Selected: "Illustration%_Selected",

  InvestmentAmountChanged: "InvestmentAmountChanged",
  JointLifeDetailPopupOpen: "JointLifeDetailPopupOpen",
  JointLifeEditDetailPopupOpen: "JointLifeEditDetailPopupOpen",
  JointLifeDetailPopupClose: "JointLifeDetailPopupClose",
  JointLifeDetailSubmit: "JointLifeDetailSubmit",

  HRateForHigherInv_Clicked: "HRateForHigherInv_Clicked",
  HRateForHigherInv_PopupOpen: "HRateForHigherInv_PopupOpen",
  HRateForHigherInv_PopupClose: "HRateForHigherInv_PopupClose",
  HRateForHigherInv_Okay: "HRateForHigherInv_Okay",
  ReceivePension: "ReceivePension",
  PensionSelected_For: "PensionSelected_For",
  OnlineBenefits_GetExtraOnline: "OnlineBenefits_GetExtraOnline",
  OnlineBenefits_ConnectNow: "OnlineBenefits_ConnectNow",

  Illustration3_Selected: "Illustration3_Selected",
  LoyaltyBonuse_Selected: "LoyaltyBonuse_Selected",
  LoyaltyBonuse_PopupOpen: "LoyaltyBonuse_PopupOpen",
  LoyaltyBonuse_PopupClose: "LoyaltyBonuse_PopupClose",
  LoyaltyBonuse_OkGotIt: "LoyaltyBonuse_OkGotIt",
  PlanEligibility_Selected: "PlanEligibility_Selected",
  PlanEligibility_PopupOpen: "PlanEligibility_PopupOpen",
  PlanEligibility_OkClicked: "PlanEligibility_OkClicked",
  PlanEligibility_PopupClose: "PlanEligibility_PopupClose",
  PlanEligibility_OkGotIt: "PlanEligibility_OkGotIt",
  PlanEligibility_ReferTable: "PlanEligibility_ReferTable",
  FundPerformance_All: "FundPerformance_All",
  FundPerformance_Equity: "FundPerformance_Equity",
  FundPerformance_Balanced: "FundPerformance_Balanced",
  FundPerformance_Debt: "FundPerformance_Debt",
  FundPerformance_Next: "FundPerformance_Next",
  FundPerformance_Previous: "FundPerformance_Previous",
  DocumentLink_Selected: "DocumentLink_Selected",
  DocumentLink_PopupOpen: "DocumentLink_PopupOpen",
  DocumentLink_PopupClose: "DocumentLink_PopupClose",
  PolicyHolder_Selected: "PolicyHolder_Selected",
  CallUsToday_Click: "CallUsToday_Click",
  Eligibility_RegularPay: "Eligibility_RegularPay",
  Eligibility_LimitedPay: "Eligibility_LimitedPay",
  Eligibility_SinglePay: "Eligibility_SinglePay",
  iPSAppForm_HealthInfo_weight: "iPSAppForm_HealthInfo_weight",
  tobacco: "iPSAppForm_HealthInfo_HQ05",
  narcotics: "iPSAppForm_HealthInfo_HQ07",
  alcohol: "iPSAppForm_HealthInfo_HQ06",
  armedForces: "iPSAppForm_HealthInfo_HQ125",
  hazardousOccupation: "iPSAppForm_HealthInfo_HQ09",
  medicalHistory: "iPSAppForm_HealthInfo_HQ166",
  iPSAppForm_HealthInfo_HQ167_All_Fields: "iPSAppForm_HealthInfo_HQ167_All_Fields",
  hivInfection: "iPSAppForm_HealthInfo_CHQ14",
  seriousInjury: "iPSAppForm_HealthInfo_HQ24",
  iPSAppForm_HealthInfo_CHQ38: "iPSAppForm_HealthInfo_CHQ38",
  iPSAppForm_HealthInfo_CHQ43: "iPSAppForm_HealthInfo_CHQ43",
  iPSAppForm_HealthInfo_CHQ56: "iPSAppForm_HealthInfo_CHQ56",
  eKyc_Adhaar_OTP_Verified: "eKyc_Adhaar_OTP_Verified",
  ClaimSettlementProcess_Selected: "ClaimSettlementProcess_Selected",
  ClaimSettlementProcess_PopupOpen: "ClaimSettlementProcess_PopupOpen",
  ClaimSettlementProcess_CheckPremium: "ClaimSettlementProcess_CheckPremium",
  iPSAppForm_ProceedToPayment: "ProceedToPayment_DecOK",
  iPSAppForm_EditDetails: "iPSAppForm_EditDetails",
  iPSAppForm_PersonalInfo_prmnt_address2: "iPSAppForm_PersonalInfo_prmnt_address2",
  iPSAppForm_PersonalInfo_prmnt_landmark: "iPSAppForm_PersonalInfo_prmnt_landmark",
  iPSAppForm_PersonalInfo_prmnt_pinCode: "iPSAppForm_PersonalInfo_prmnt_pinCode",
  iPSAppForm_PersonalInfo_prmnt_city: "iPSAppForm_PersonalInfo_prmnt_city",
  iPSAppForm_PersonalInfo_address1: "iPSAppForm_PersonalInfo_address1",
  iPSAppForm_PersonalInfo_address2: "iPSAppForm_PersonalInfo_address2",
  iPSAppForm_PersonalInfo_city: "iPSAppForm_PersonalInfo_city",
  iPSAppForm_PersonalInfo_occ: "iPSAppForm_PersonalInfo_occ",
  iPSAppForm_PersonalInfo_education: "iPSAppForm_PersonalInfo_education",
  iPSAppForm_HealthInfo_remarks: "iPSAppForm_HealthInfo_remarks",
  iPSAppForm_PersonalInfo_marriedProtectAct: "iPSAppForm_PersonalInfo_marriedProtectAct",
  iPSAppForm_PersonalInfo_prmnt_address1: "iPSAppForm_PersonalInfo_prmnt_address1",
  iPSAppForm_PersonalInfo_state: "iPSAppForm_PersonalInfo_state",
  iPSAppForm_PersonalInfo_pinCode: "iPSAppForm_PersonalInfo_pinCode",
  iPSAppForm_PersonalInfo_prmnt_state: "iPSAppForm_PersonalInfo_prmnt_state",
  iPSAppForm_PersonalInfo_eiaInsuranceRepository: "iPSAppForm_PersonalInfo_eiaInsuranceRepository",
  iPSAppForm_PersonalInfo_isEIAOpted: "iPSAppForm_PersonalInfo_isEIAOpted",
  iPSAppForm_PersonalInfo_EIAAccountNumber: "iPSAppForm_PersonalInfo_EIAAccountNumber",
  iPSAppForm_PersonalInfo_criminal_offence: "iPSAppForm_PersonalInfo_criminal_offence",
  iPSAppForm_PersonalInfo_politically_exposed_person: "iPSAppForm_PersonalInfo_politically_exposed_person",
  iPSAppForm_HealthInfo_HQ01: "iPSAppForm_HealthInfo_HQ01",
  gynaecological: "iPSAppForm_HealthInfo_HQ168",
  iPSAppForm_HealthInfo_HQ61: "iPSAppForm_HealthInfo_HQ61",
  iPSAppForm_EC_OTP_PopUpOpen: "iPSAppForm_EC_OTP_PopUpOpen",
  iPSAppForm_EC_OTP_Verify: "iPSAppForm_EC_OTP_Verify",
  iPSAppForm_EC_OTP_PopUpclose: "iPSAppForm_EC_OTP_PopUpclose",
  iPSAppForm_EC_OTP_Resend: "iPSAppForm_EC_OTP_Resend",
  iPSAppForm_EC_OTP_NotVerify: "iPSAppForm_EC_OTP_NotVerify",
  iPSAppForm_PersonalInfo_birth_country: "iPSAppForm_PersonalInfo_birth_country",
  iPSAppForm_PersonalInfo_nationality_status: "iPSAppForm_PersonalInfo_nationality_status",
  iPSAppForm_PersonalInfo_countryOfResidence: "iPSAppForm_PersonalInfo_countryOfResidence",
  iPSAppForm_PersonalInfo_passportNo: "iPSAppForm_PersonalInfo_passportNo",
  iPSAppForm_PersonalInfo_passportNo_fn: "iPSAppForm_PersonalInfo_passportNo_fn",
  iPSAppForm_PersonalInfo_purposeOfStay: "iPSAppForm_PersonalInfo_purposeOfStay",
  iPSAppForm_PersonalInfo_dateOfArrivingIndia: "iPSAppForm_PersonalInfo_dateOfArrivingIndia",
  iPSAppForm_PersonalInfo_dateOfLeavingIndia: "iPSAppForm_PersonalInfo_dateOfLeavingIndia",
  iPSAppForm_PersonalInfo_nameOfEmployer: "iPSAppForm_PersonalInfo_nameOfEmployer",
  iPSAppForm_PersonalInfo_DurationAbroad_month: "iPSAppForm_PersonalInfo_DurationAbroad_month",
  iPSAppForm_PersonalInfo_tin_country1: "iPSAppForm_PersonalInfo_tin_country1",
  iPSAppForm_PersonalInfo_tin_country2: "iPSAppForm_PersonalInfo_tin_country2",
  iPSAppForm_PersonalInfo_tinNum1: "iPSAppForm_PersonalInfo_tinNum1",
  iPSAppForm_PersonalInfo_tinNum2: "iPSAppForm_PersonalInfo_tinNum2",
  iPSAppForm_PersonalInfo_pio: "iPSAppForm_PersonalInfo_pio",
  iPSAppForm_PersonalInfo_bankType: "iPSAppForm_PersonalInfo_bankType",
  iPSAppForm_PersonalInfo_investigationDtls: "iPSAppForm_PersonalInfo_investigationDtls",
  iPSAppForm_PersonalInfo_cmpany1: "iPSAppForm_PersonalInfo_cmpany1",
  iPSAppForm_PersonalInfo_cmpany2: "iPSAppForm_PersonalInfo_cmpany2",
  iPSAppForm_PersonalInfo_cmpany3: "iPSAppForm_PersonalInfo_cmpany3",
  iPSAppForm_PersonalInfo_cmpany4: "iPSAppForm_PersonalInfo_cmpany4",
  iPSAppForm_PersonalInfo_cmpany5: "iPSAppForm_PersonalInfo_cmpany5",
  iPSAppForm_PersonalInfo_cmpanyothers1: "iPSAppForm_PersonalInfo_cmpanyothers1",
  iPSAppForm_PersonalInfo_cmpanyothers2: "iPSAppForm_PersonalInfo_cmpanyothers2",
  iPSAppForm_PersonalInfo_cmpanyothers3: "iPSAppForm_PersonalInfo_cmpanyothers3",
  iPSAppForm_PersonalInfo_cmpanyothers4: "iPSAppForm_PersonalInfo_cmpanyothers4",
  iPSAppForm_PersonalInfo_cmpanyothers5: "iPSAppForm_PersonalInfo_cmpanyothers5",
  iPSAppForm_PersonalInfo_myProfession: "iPSAppForm_PersonalInfo_myProfession",
  iPSAppForm_PersonalInfo_bene_fname1: "iPSAppForm_PersonalInfo_bene_fname1",
  iPSAppForm_PersonalInfo_bene_fname2: "iPSAppForm_PersonalInfo_bene_fname2",
  iPSAppForm_PersonalInfo_bene_fname3: "iPSAppForm_PersonalInfo_bene_fname3",
  iPSAppForm_PersonalInfo_bene_fname4: "iPSAppForm_PersonalInfo_bene_fname4",
  iPSAppForm_PersonalInfo_bene_fname5: "iPSAppForm_PersonalInfo_bene_fname5",
  iPSAppForm_PersonalInfo_bene_fname6: "iPSAppForm_PersonalInfo_bene_fname6",
  iPSAppForm_PersonalInfo_bene_share1: "iPSAppForm_PersonalInfo_bene_share1",
  iPSAppForm_PersonalInfo_bene_share2: "iPSAppForm_PersonalInfo_bene_share2",
  iPSAppForm_PersonalInfo_bene_share3: "iPSAppForm_PersonalInfo_bene_share3",
  iPSAppForm_PersonalInfo_bene_share4: "iPSAppForm_PersonalInfo_bene_share4",
  iPSAppForm_PersonalInfo_bene_share5: "iPSAppForm_PersonalInfo_bene_share5",
  iPSAppForm_PersonalInfo_bene_share6: "iPSAppForm_PersonalInfo_bene_share6",
  iPSAppForm_PersonalInfo_bene_reln1: "iPSAppForm_PersonalInfo_bene_reln1",
  iPSAppForm_PersonalInfo_bene_reln2: "iPSAppForm_PersonalInfo_bene_reln2",
  iPSAppForm_PersonalInfo_bene_reln3: "iPSAppForm_PersonalInfo_bene_reln3",
  iPSAppForm_PersonalInfo_bene_reln4: "iPSAppForm_PersonalInfo_bene_reln4",
  iPSAppForm_PersonalInfo_bene_reln5: "iPSAppForm_PersonalInfo_bene_reln5",
  iPSAppForm_PersonalInfo_bene_reln6: "iPSAppForm_PersonalInfo_bene_reln6",
  iPSAppForm_PersonalInfo_bene_dob1: "iPSAppForm_PersonalInfo_bene_dob1",
  iPSAppForm_PersonalInfo_bene_dob2: "iPSAppForm_PersonalInfo_bene_dob2",
  iPSAppForm_PersonalInfo_bene_dob3: "iPSAppForm_PersonalInfo_bene_dob3",
  iPSAppForm_PersonalInfo_bene_dob4: "iPSAppForm_PersonalInfo_bene_dob4",
  iPSAppForm_PersonalInfo_bene_dob5: "iPSAppForm_PersonalInfo_bene_dob5",
  iPSAppForm_PersonalInfo_bene_dob6: "iPSAppForm_PersonalInfo_bene_dob6",
  iPSAppForm_HealthInfo_nameOfCountry0: "iPSAppForm_HealthInfo_nameOfCountry0",
  iPSAppForm_HealthInfo_city0: "iPSAppForm_HealthInfo_city0",
  iPSAppForm_HealthInfo_arrivalDate0: "iPSAppForm_HealthInfo_arrivalDate0",
  iPSAppForm_HealthInfo_departureDate0: "iPSAppForm_HealthInfo_departureDate0",
  iPSAppForm_HealthInfo_safetyPrecaution: "iPSAppForm_HealthInfo_safetyPrecaution",
  iPSAppForm_HealthInfo_visaType0: "iPSAppForm_HealthInfo_visaType0",
  iPSAppForm_HealthInfo_purposeOfTravel0: "iPSAppForm_HealthInfo_purposeOfTravel0",
  iPSAppForm_HealthInfo_typeOfResidence0: "iPSAppForm_HealthInfo_typeOfResidence0",
  iPSAppForm_HealthInfo_natureOfBusiness: "iPSAppForm_HealthInfo_natureOfBusiness",
  iPSAppForm_HealthInfo_modeOfTravel: "iPSAppForm_HealthInfo_modeOfTravel",
  EBI_Download: "EBI_Download",
  ClaimforSure_PopupOpen: "ClaimforSure_PopupOpen",
  ClaimforSure_PopupClose: "ClaimforSure_PopupClose",
  ClaimforSure_Selected: "ClaimforSure_Selected",
  iPSAppForm_PersonalInfo_sum1: "iPSAppForm_PersonalInfo_sum1",
  iPSAppForm_PersonalInfo_sum2: "iPSAppForm_PersonalInfo_sum2",
  iPSAppForm_PersonalInfo_sum3: "iPSAppForm_PersonalInfo_sum3",
  iPSAppForm_PersonalInfo_sum4: "iPSAppForm_PersonalInfo_sum4",
  iPSAppForm_PersonalInfo_sum5: "iPSAppForm_PersonalInfo_sum5",
  iPSAppForm_PersonalInfo_addPolicy1: "iPSAppForm_PersonalInfo_addPolicy1",
  iPSAppForm_PersonalInfo_addPolicy2: "iPSAppForm_PersonalInfo_addPolicy2",
  iPSAppForm_PersonalInfo_addPolicy3: "iPSAppForm_PersonalInfo_addPolicy3",
  iPSAppForm_PersonalInfo_addPolicy4: "iPSAppForm_PersonalInfo_addPolicy4",
  iPSAppForm_PersonalInfo_addPolicy5: "iPSAppForm_PersonalInfo_addPolicy5",
  iPSAppForm_PersonalInfo_Completed: "iPSAppForm_PersonalInfo_Completed",
  iPSAppForm_HealthlInfo_Started: "iPSAppForm_HealthlInfo_Started",
  LifeCover_Increased: "LifeCover_Increased",
  LifeCover_Decreased: "LifeCover_Decreased",
  HigherLifeCover_PopupOpen: "HigherLifeCover_PopupOpen",
  HigherLifeCover_PopupClose: "HigherLifeCover_PopupClose",
  HigherLifeCover_saveClick: "HigherLifeCover_Save",
  PolicyTerm_Decreased: "PolicyTerm_Decreased",
  PolicyTerm_Increased: "PolicyTerm_Increased",
  CriticalIllness_AddOnSelected: "CriticalIllness_AddOnSelected",
  Listof34CriticalIllness_Popupopen: "Listof34CriticalIllness_Popupopen",
  Listof34CriticalIllness_CheckPremium: "Listof34CriticalIllness_CheckPremium",
  Listof34CriticalIllness_Clicked: "Listof34CriticalIllness_Clicked",
  Listof34CriticalIllness_Ok: "Listof34CriticalIllness_Ok",
  AccidentalDeath_AddOnSelected: "AccidentalDeath_AddOnSelected",
  AccidentalDeathCover_Ok: "AccidentalDeathCover_Ok",
  Diabetes_PopupClose: "Diabetes_PopupClose",
  Diabetes_PopupOpen: "Diabetes_PopupOpen",
  ClaimCorner_Selected: "ClaimCorner_Selected",
  ClaimsCorner_Click: "ClaimsCorner_Click",
  ClaimsCorner_PopupClose: "ClaimsCorner_PopupClose",
  Claims_corner_PopupOpen: "Claims_corner_PopupOpen",
  Benefit_Removed: "Benefit_Removed",
  change_diabetes_status: "change_diabetes_status",
  DocList_Clicked: "DocList_Clicked",
  DocList_Opened: "DocList_Opened",
  DocList_Closed: "DocList_Closed",
  ProceedwithoutAdhaar_CompleteFormMyself: "ProceedwithoutAdhaar_CompleteFormMyself",
  NRI_Availability_PopupOpen: "NRI_Availability_PopupOpen",
  NRIHelpDesk_Selected: "NRIHelpDesk_Selected",
  NRIHelpDesk_PopupOpen: "NRIHelpDesk_PopupOpen",
  NRIHelpDesk_PopupClose: "NRIHelpDesk_PopupClose",
  NRIHelpDesk_ConnectNow: "NRIHelpDesk_ConnectNow",
  NRINo_CheckPremium: "NRINo_CheckPremium",
  NRIYes_CheckPremium: "NRIYes_CheckPremium",
  ProductGuide_Download: "ProductGuide_Download",
  TalktoExpert_PopupClose: "TalktoExpert_PopupClose",
  GroupEmployee_PopupOpen: "GroupEmployee_PopupOpen",
  GroupEmployeePopUp_Closed: "GroupEmployeePopUp_Closed",
  eKyc_ProceedwithoutAdhaar_Selected: "eKyc_ProceedwithoutAdhaar_Selected",
  GroupEmployee_Confirmed: "GroupEmployee_Confirmed",
  GroupEmployee_NotVerified: "GroupEmployee_NotVerified",
  ProceedwithoutAdhaar_QuickFillAadhaar: "ProceedwithoutAdhaar_QuickFillAadhaar",
  NRI_Availability_PopupClose: "NRI_Availability_PopupClose",
  ViewBreakup: "ViewBreakup",
  "EKYC_T&CAccepted": "EKYC_T&CAccepted",
  MismatchDOB_StartAgain_Click: "MismatchDOB_StartAgain_Click",

  PaymentTerm_Limited_Pay_5yearToRegular_Pay: "PaymentTerm_Limited_Pay_5yearToRegular_Pay",
  PaymentTerm_Regular_PayToLimited_Pay_5year: "PaymentTerm_Regular_PayToLimited_Pay_5year",
  PaymentTerm_Regular_PayToLimited_Pay_10year: "PaymentTerm_Regular_PayToLimited_Pay_10year",
  PaymentTerm_Regular_PayToSingle_Pay: "PaymentTerm_Regular_PayToSingle_Pay",
  PaymentTerm_Regular_PayToLimited_Pay_term_5_year: "PaymentTerm_Regular_PayToLimited_Pay_term_5_year",
  PaymentTerm_Limited_Pay_5yearToLimited_Pay_7year: "PaymentTerm_Limited_Pay_5yearToLimited_Pay_7year",
  PaymentTerm_Regular_PayToWhole_Life_Regular_Pay: "PaymentTerm_Regular_PayToWhole_Life_Regular_Pay",
  PaymentTerm_Limited_Pay_10yearToRegular_Pay: "PaymentTerm_Limited_Pay_10yearToRegular_Pay",
  PaymentTerm_Regular_PayToLimited_Pay_7year: "PaymentTerm_Regular_PayToLimited_Pay_7year",
  PaymentTerm_Regular_PayToLimited_Pay_60_age: "PaymentTerm_Regular_PayToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_7yearToLimited_Pay_10year: "PaymentTerm_Limited_Pay_7yearToLimited_Pay_10year",
  PaymentTerm_Limited_Pay_5yearToLimited_Pay_10year: "PaymentTerm_Limited_Pay_5yearToLimited_Pay_10year",
  PaymentTerm_Regular_PayToLimited_Pay_15year: "PaymentTerm_Regular_PayToLimited_Pay_15year",
  PaymentTerm_Limited_Pay_term_5_yearToRegular_Pay: "PaymentTerm_Limited_Pay_term_5_yearToRegular_Pay",
  PaymentTerm_Regular_PayToRegular_Pay: "PaymentTerm_Regular_PayToRegular_Pay",
  PaymentTerm_Single_PayToRegular_Pay: "PaymentTerm_Single_PayToRegular_Pay",
  PaymentTerm_Whole_Life_Regular_PayToRegular_Pay: "PaymentTerm_Whole_Life_Regular_PayToRegular_Pay",
  PaymentTerm_Limited_Pay_7yearToLimited_Pay_5year: "PaymentTerm_Limited_Pay_7yearToLimited_Pay_5year",
  PaymentTerm_Limited_Pay_10yearToLimited_Pay_15year: "PaymentTerm_Limited_Pay_10yearToLimited_Pay_15year",
  PaymentTerm_Limited_Pay_7yearToRegular_Pay: "PaymentTerm_Limited_Pay_7yearToRegular_Pay",
  PaymentTerm_Limited_Pay_10yearToLimited_Pay_5year: "PaymentTerm_Limited_Pay_10yearToLimited_Pay_5year",
  PaymentTerm_Limited_Pay_10yearToLimited_Pay_7year: "PaymentTerm_Limited_Pay_10yearToLimited_Pay_7year",
  PaymentTerm_Limited_Pay_5yearToSingle_Pay: "PaymentTerm_Limited_Pay_5yearToSingle_Pay",
  PaymentTerm_Limited_Pay_60_ageToRegular_Pay: "PaymentTerm_Limited_Pay_60_ageToRegular_Pay",
  PaymentTerm_Limited_Pay_15yearToLimited_Pay_10year: "PaymentTerm_Limited_Pay_15yearToLimited_Pay_10year",
  PaymentTerm_Single_PayToLimited_Pay_term_5_year: "PaymentTerm_Single_PayToLimited_Pay_term_5_year",
  PaymentTerm_Limited_Pay_10yearToLimited_Pay_term_5_year: "PaymentTerm_Limited_Pay_10yearToLimited_Pay_term_5_year",
  PaymentTerm_Limited_Pay_15yearToRegular_Pay: "PaymentTerm_Limited_Pay_15yearToRegular_Pay",
  PaymentTerm_Single_PayToLimited_Pay_5year: "PaymentTerm_Single_PayToLimited_Pay_5year",
  PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_10year: "PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_10year",
  PaymentTerm_Limited_Pay_10yearToLimited_Pay_60_age: "PaymentTerm_Limited_Pay_10yearToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_5yearToLimited_Pay_term_5_year: "PaymentTerm_Limited_Pay_5yearToLimited_Pay_term_5_year",
  PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_60_age: "PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_term_5_yearToSingle_Pay: "PaymentTerm_Limited_Pay_term_5_yearToSingle_Pay",
  PaymentTerm_Limited_Pay_60_ageToLimited_Pay_term_5_year: "PaymentTerm_Limited_Pay_60_ageToLimited_Pay_term_5_year",
  PaymentTerm_Limited_Pay_15yearToLimited_Pay_60_age: "PaymentTerm_Limited_Pay_15yearToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_60_ageToLimited_Pay_10year: "PaymentTerm_Limited_Pay_60_ageToLimited_Pay_10year",
  PaymentTerm_Whole_Life_Regular_PayToWhole_Life_Limited_Pay_10:
    "PaymentTerm_Whole_Life_Regular_PayToWhole_Life_Limited_Pay_10",
  PaymentTerm_Limited_Pay_10yearToSingle_Pay: "PaymentTerm_Limited_Pay_10yearToSingle_Pay",
  PaymentTerm_Limited_Pay_15yearToLimited_Pay_term_5_year: "PaymentTerm_Limited_Pay_15yearToLimited_Pay_term_5_year",
  PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_5year: "PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_5year",
  PaymentTerm_Whole_Life_Limited_Pay_10ToLimited_Pay_5year: "PaymentTerm_Whole_Life_Limited_Pay_10ToLimited_Pay_5year",
  PaymentTerm_Limited_Pay_60_ageToLimited_Pay_15year: "PaymentTerm_Limited_Pay_60_ageToLimited_Pay_15year",
  PaymentTerm_Single_PayToLimited_Pay_10year: "PaymentTerm_Single_PayToLimited_Pay_10year",
  PaymentTerm_Limited_Pay_5yearToLimited_Pay_15year: "PaymentTerm_Limited_Pay_5yearToLimited_Pay_15year",
  PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_15year: "PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_15year",
  PaymentTerm_Limited_Pay_5yearToLimited_Pay_60_age: "PaymentTerm_Limited_Pay_5yearToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_5yearToWhole_Life_Limited_Pay_10: "PaymentTerm_Limited_Pay_5yearToWhole_Life_Limited_Pay_10",
  PaymentTerm_Whole_Life_Limited_Pay_10ToWhole_Life_Regular_Pay:
    "PaymentTerm_Whole_Life_Limited_Pay_10ToWhole_Life_Regular_Pay",
  PaymentTerm_Limited_Pay_15yearToLimited_Pay_5year: "PaymentTerm_Limited_Pay_15yearToLimited_Pay_5year",
  PaymentTerm_Limited_Pay_60_ageToLimited_Pay_5year: "PaymentTerm_Limited_Pay_60_ageToLimited_Pay_5year",
  PaymentTerm_Whole_Life_Limited_Pay_10ToWhole_Life_Limited_Pay_60_age:
    "PaymentTerm_Whole_Life_Limited_Pay_10ToWhole_Life_Limited_Pay_60_age",
  PaymentTerm_Limited_Pay_7yearToLimited_Pay_term_5_year: "PaymentTerm_Limited_Pay_7yearToLimited_Pay_term_5_year",
  PaymentTerm_Whole_Life_Regular_PayToWhole_Life_Limited_Pay_60_age:
    "PaymentTerm_Whole_Life_Regular_PayToWhole_Life_Limited_Pay_60_age",
  PaymentTerm_Limited_Pay_7yearToSingle_Pay: "PaymentTerm_Limited_Pay_7yearToSingle_Pay",
  PaymentTerm_Limited_Pay_10yearToWhole_Life_Limited_Pay_10:
    "PaymentTerm_Limited_Pay_10yearToWhole_Life_Limited_Pay_10",
  PaymentTerm_Limited_Pay_60_ageToSingle_Pay: "PaymentTerm_Limited_Pay_60_ageToSingle_Pay",
  PaymentTerm_Single_PayToLimited_Pay_7year: "PaymentTerm_Single_PayToLimited_Pay_7year",
  PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_7year: "PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_7year",
  PaymentTerm_Limited_Pay_7yearToLimited_Pay_15year: "PaymentTerm_Limited_Pay_7yearToLimited_Pay_15year",
  PaymentTerm_Limited_Pay_15yearToSingle_Pay: "PaymentTerm_Limited_Pay_15yearToSingle_Pay",
  PaymentTerm_Whole_Life_Limited_Pay_60_ageToWhole_Life_Limited_Pay_10:
    "PaymentTerm_Whole_Life_Limited_Pay_60_ageToWhole_Life_Limited_Pay_10",
  PaymentTerm_Whole_Life_Limited_Pay_60_ageToLimited_Pay_5year:
    "PaymentTerm_Whole_Life_Limited_Pay_60_ageToLimited_Pay_5year",
  PaymentTerm_Limited_Pay_7yearToLimited_Pay_60_age: "PaymentTerm_Limited_Pay_7yearToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_60_ageToLimited_Pay_7year: "PaymentTerm_Limited_Pay_60_ageToLimited_Pay_7year",
  PaymentTerm_Whole_Life_Limited_Pay_60_ageToWhole_Life_Regular_Pay:
    "PaymentTerm_Whole_Life_Limited_Pay_60_ageToWhole_Life_Regular_Pay",
  PaymentTerm_Limited_Pay_15yearToLimited_Pay_7year: "PaymentTerm_Limited_Pay_15yearToLimited_Pay_7year",
  PaymentTerm_Whole_Life_Limited_Pay_10ToRegular_Pay: "PaymentTerm_Whole_Life_Limited_Pay_10ToRegular_Pay",
  PaymentTerm_Limited_Pay_15yearToWhole_Life_Limited_Pay_10:
    "PaymentTerm_Limited_Pay_15yearToWhole_Life_Limited_Pay_10",
  PaymentTerm_Limited_Pay_60_ageToWhole_Life_Limited_Pay_10:
    "PaymentTerm_Limited_Pay_60_ageToWhole_Life_Limited_Pay_10",
  PaymentTerm_Limited_Pay_7yearToWhole_Life_Limited_Pay_10: "PaymentTerm_Limited_Pay_7yearToWhole_Life_Limited_Pay_10",
  PaymentTerm_Limited_Pay_term_5_yearToWhole_Life_Limited_Pay_10:
    "PaymentTerm_Limited_Pay_term_5_yearToWhole_Life_Limited_Pay_10",
  PaymentTerm_Whole_Life_Limited_Pay_60_ageToRegular_Pay: "PaymentTerm_Whole_Life_Limited_Pay_60_ageToRegular_Pay",
  PaymentTerm_Limited_Pay_5yearToLimited_Pay_5year: "PaymentTerm_Limited_Pay_5yearToLimited_Pay_5year",
  PaymentTerm_Single_PayToLimited_Pay_60_age: "PaymentTerm_Single_PayToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_10yearToLimited_Pay_10year: "PaymentTerm_Limited_Pay_10yearToLimited_Pay_10year",
  PaymentTerm_Single_PayToSingle_Pay: "PaymentTerm_Single_PayToSingle_Pay",
  PaymentTerm_Limited_Pay_7yearToLimited_Pay_7year: "PaymentTerm_Limited_Pay_7yearToLimited_Pay_7year",
  PaymentTerm_Whole_Life_Regular_PayToWhole_Life_Regular_Pay:
    "PaymentTerm_Whole_Life_Regular_PayToWhole_Life_Regular_Pay",
  PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_term_5_year:
    "PaymentTerm_Limited_Pay_term_5_yearToLimited_Pay_term_5_year",
  PaymentTerm_Regular_PayToWhole_Life_Limited_Pay_10: "PaymentTerm_Regular_PayToWhole_Life_Limited_Pay_10",
  PaymentTerm_Limited_Pay_60_ageToLimited_Pay_60_age: "PaymentTerm_Limited_Pay_60_ageToLimited_Pay_60_age",
  PaymentTerm_Limited_Pay_5yearToWhole_Life_Regular_Pay: "PaymentTerm_Limited_Pay_5yearToWhole_Life_Regular_Pay",
  PaymentTerm_Single_PayToLimited_Pay_15year: "PaymentTerm_Single_PayToLimited_Pay_15year",
  PayoutOption_LumpSumToRIncome: "PayoutOption_LumpSumToRIncome",
  PayoutOption_RIncomeToLumpSum: "PayoutOption_RIncomeToLumpSum",
  PayoutOption_LumpSumToLRIncome: "PayoutOption_LumpSumToLRIncome",
  PayoutOption_RIncomeToIIncome: "PayoutOption_RIncomeToIIncome",
  PayoutOption_LRIncomeToLumpSum: "PayoutOption_LRIncomeToLumpSum",
  PayoutOption_IIncomeToLRIncome: "PayoutOption_IIncomeToLRIncome",
  PayoutOption_LumpSumToIIncome: "PayoutOption_LumpSumToIIncome",
  PayoutOption_IIncomeToRIncome: "PayoutOption_IIncomeToRIncome",
  PayoutOption_RIncomeToLRIncome: "PayoutOption_RIncomeToLRIncome",
  PayoutOption_LumpSumToLumpSum: "PayoutOption_LumpSumToLumpSum",
  PayoutOption_IIncomeToLumpSum: "PayoutOption_IIncomeToLumpSum",
  PayoutOption_LRIncomeToIIncome: "PayoutOption_LRIncomeToIIncome",
  PayoutOption_LRIncomeToRIncome: "PayoutOption_LRIncomeToRIncome",
  PayoutOption_RIncomeToRIncome: "PayoutOption_RIncomeToRIncome",
  PayoutOption_LRIncomeToLRIncome: "PayoutOption_LRIncomeToLRIncome",
  PayoutOption_IIncomeToIIncome: "PayoutOption_IIncomeToIIncome",
  ProceedToApplication: "ProceedToApplication",
  QuoteSeen: "QuoteSeen",
  iPSAppForm_PersonalInfo_orgTypeDesc: "iPSAppForm_PersonalInfo_orgTypeDesc",
  iPSAppForm_PersonalInfo_occDesc: "iPSAppForm_PersonalInfo_occDesc",
  iPSAppForm_PersonalInfo_prmnt_address3: "iPSAppForm_PersonalInfo_prmnt_address3",
  iPSAppForm_country_nationality_fn_PreviousSelected: "iPSAppForm_country_nationality_fn_PreviousSelected",
  iPSAppForm_dateOfArrivingIndia_fn_PreviousSelected: "iPSAppForm_dateOfArrivingIndia_fn_PreviousSelected",
  iPSAppForm_purposeOfStay_fn_PreviousSelected: "iPSAppForm_purposeOfStay_fn_PreviousSelected",
  iPSAppForm_country_nationality_PreviousSelected: "iPSAppForm_country_nationality_PreviousSelected",

  iPSAppForm_address1_PreviousSelected: "iPSAppForm_address1_PreviousSelected",
  iPSAppForm_occ_PreviousSelected: "iPSAppForm_occ_PreviousSelected",
  iPSAppForm_preferred_age_proof_PreviousSelected: "iPSAppForm_preferred_age_proof_PreviousSelected",
  iPSAppForm_frstNm_PreviousSelected: "iPSAppForm_frstNm_PreviousSelected",
  iPSAppForm_orgType_PreviousSelected: "iPSAppForm_orgType_PreviousSelected",
  iPSAppForm_panNo_PreviousSelected: "iPSAppForm_panNo_PreviousSelected",
  iPSAppForm_addCommunication_PreviousSelected: "iPSAppForm_addCommunication_PreviousSelected",
  iPSAppForm_education_PreviousSelected: "iPSAppForm_education_PreviousSelected",
  iPSAppForm_landmark_PreviousSelected: "iPSAppForm_landmark_PreviousSelected",
  iPSAppForm_nameOfOrg_PreviousSelected: "iPSAppForm_nameOfOrg_PreviousSelected",
  iPSAppForm_city_PreviousSelected: "iPSAppForm_city_PreviousSelected",
  iPSAppForm_prmnt_address1_PreviousSelected: "iPSAppForm_prmnt_address1_PreviousSelected",
  iPSAppForm_HQ144_PreviousSelected: "iPSAppForm_HQ144_PreviousSelected",
  iPSAppForm_preferred_identity_proof_PreviousSelected: "iPSAppForm_preferred_identity_proof_PreviousSelected",
  iPSAppForm_mrtlSts_PreviousSelected: "iPSAppForm_mrtlSts_PreviousSelected",
  iPSAppForm_insuranceInfos_PreviousSelected: "iPSAppForm_insuranceInfos_PreviousSelected",
  iPSAppForm_relationship_PreviousSelected: "iPSAppForm_relationship_PreviousSelected",
  iPSAppForm_state_PreviousSelected: "iPSAppForm_state_PreviousSelected",
  iPSAppForm_CHQ30_PreviousSelected: "iPSAppForm_CHQ30_PreviousSelected",
  iPSAppForm_CHQ14_PreviousSelected: "iPSAppForm_CHQ14_PreviousSelected",
  iPSAppForm_criminal_offence_PreviousSelected: "iPSAppForm_criminal_offence_PreviousSelected",
  "iPSAppForm_app-label-a_PreviousSelected": "iPSAppForm_app-label-a_PreviousSelected",
  iPSAppForm_cmpany1_PreviousSelected: "iPSAppForm_cmpany1_PreviousSelected",
  iPSAppForm_cmpany2_PreviousSelected: "iPSAppForm_cmpany2_PreviousSelected",
  iPSAppForm_cmpany3_PreviousSelected: "iPSAppForm_cmpany3_PreviousSelected",
  iPSAppForm_cmpany4_PreviousSelected: "iPSAppForm_cmpany4_PreviousSelected",
  iPSAppForm_cmpany5_PreviousSelected: "iPSAppForm_cmpany5_PreviousSelected",
  iPSAppForm_cmpanyothers1_PreviousSelected: "iPSAppForm_cmpanyothers1_PreviousSelected",
  iPSAppForm_cmpanyothers2_PreviousSelected: "iPSAppForm_cmpanyothers2_PreviousSelected",
  iPSAppForm_cmpanyothers3_PreviousSelected: "iPSAppForm_cmpanyothers3_PreviousSelected",
  iPSAppForm_cmpanyothers4_PreviousSelected: "iPSAppForm_cmpanyothers4_PreviousSelected",
  iPSAppForm_cmpanyothers5_PreviousSelected: "iPSAppForm_cmpanyothers5_PreviousSelected",
  iPSAppForm_pinCode_PreviousSelected: "iPSAppForm_pinCode_PreviousSelected",
  iPSAppForm_emailAddress_PreviousSelected: "iPSAppForm_emailAddress_PreviousSelected",
  iPSAppForm_preferred_address_proof_PreviousSelected: "iPSAppForm_preferred_address_proof_PreviousSelected",
  iPSAppForm_prmnt_state_PreviousSelected: "iPSAppForm_prmnt_state_PreviousSelected",
  iPSAppForm_prmnt_pinCode_PreviousSelected: "iPSAppForm_prmnt_pinCode_PreviousSelected",
  iPSAppForm_CHQ33_PreviousSelected: "iPSAppForm_CHQ33_PreviousSelected",
  iPSAppForm_mobileNumber_PreviousSelected: "iPSAppForm_mobileNumber_PreviousSelected",
  iPSAppForm_CHQ32_PreviousSelected: "iPSAppForm_CHQ32_PreviousSelected",
  iPSAppForm_prmnt_city_PreviousSelected: "iPSAppForm_prmnt_city_PreviousSelected",
  iPSAppForm_CHQ31_PreviousSelected: "iPSAppForm_CHQ31_PreviousSelected",
  iPSAppForm_CHQ38_PreviousSelected: "iPSAppForm_CHQ38_PreviousSelected",
  iPSAppForm_HQ166_PreviousSelected: "iPSAppForm_HQ166_PreviousSelected",
  iPSAppForm_HQ06_PreviousSelected: "iPSAppForm_HQ06_PreviousSelected",
  iPSAppForm_CHQ15_PreviousSelected: "iPSAppForm_CHQ15_PreviousSelected",
  iPSAppForm_prmnt_landmark_PreviousSelected: "iPSAppForm_prmnt_landmark_PreviousSelected",
  iPSAppForm_nomineefrstNm_PreviousSelected: "iPSAppForm_nomineefrstNm_PreviousSelected",
  iPSAppForm_HQ24_PreviousSelected: "iPSAppForm_HQ24_PreviousSelected",
  iPSAppForm_CHQ56_PreviousSelected: "iPSAppForm_CHQ56_PreviousSelected",
  iPSAppForm_CHQ19_PreviousSelected: "iPSAppForm_CHQ19_PreviousSelected",
  iPSAppForm_healthDec_medicalCondt_PreviousSelected: "iPSAppForm_healthDec_medicalCondt_PreviousSelected",
  iPSAppForm_CHQ21_PreviousSelected: "iPSAppForm_CHQ21_PreviousSelected",
  iPSAppForm_CHQ43_PreviousSelected: "iPSAppForm_CHQ43_PreviousSelected",
  iPSAppForm_CHQ20_PreviousSelected: "iPSAppForm_CHQ20_PreviousSelected",
  iPSAppForm_CHQ36_PreviousSelected: "iPSAppForm_CHQ36_PreviousSelected",
  iPSAppForm_weight_PreviousSelected: "iPSAppForm_weight_PreviousSelected",
  iPSAppForm_HQ07_PreviousSelected: "iPSAppForm_HQ07_PreviousSelected",
  iPSAppForm_healthDec_diagnosis_PreviousSelected: "iPSAppForm_healthDec_diagnosis_PreviousSelected",
  iPSAppForm_feet_PreviousSelected: "iPSAppForm_feet_PreviousSelected",
  iPSAppForm_HQ09_PreviousSelected: "iPSAppForm_HQ09_PreviousSelected",
  iPSAppForm_HQ125_PreviousSelected: "iPSAppForm_HQ125_PreviousSelected",
  iPSAppForm_CHQ16_PreviousSelected: "iPSAppForm_CHQ16_PreviousSelected",
  iPSAppForm_healthDec_details_PreviousSelected: "iPSAppForm_healthDec_details_PreviousSelected",
  iPSAppForm_nomineeDob_PreviousSelected: "iPSAppForm_nomineeDob_PreviousSelected",
  iPSAppForm_CHQ35_PreviousSelected: "iPSAppForm_CHQ35_PreviousSelected",
  iPSAppForm_alcohol_consumedAs_PreviousSelected: "iPSAppForm_alcohol_consumedAs_PreviousSelected",
  iPSAppForm_CHQ34_PreviousSelected: "iPSAppForm_CHQ34_PreviousSelected",
  iPSAppForm_trust_type1_PreviousSelected: "iPSAppForm_trust_type1_PreviousSelected",
  iPSAppForm_healthDec_duration_PreviousSelected: "iPSAppForm_healthDec_duration_PreviousSelected",
  iPSAppForm_selfEmployeedAll_PreviousSelected: "iPSAppForm_selfEmployeedAll_PreviousSelected",
  iPSAppForm_alcohol_quantity_PreviousSelected: "iPSAppForm_alcohol_quantity_PreviousSelected",
  iPSAppForm_addPolicy1_PreviousSelected: "iPSAppForm_addPolicy1_PreviousSelected",
  iPSAppForm_add_bene1_PreviousSelected: "iPSAppForm_add_bene1_PreviousSelected",
  iPSAppForm_healthDec_currentState_PreviousSelected: "iPSAppForm_healthDec_currentState_PreviousSelected",
  iPSAppForm_sum1_PreviousSelected: "iPSAppForm_sum1_PreviousSelected",
  iPSAppForm_CHQ18_PreviousSelected: "iPSAppForm_CHQ18_PreviousSelected",
  iPSAppForm_tinNum1_PreviousSelected: "iPSAppForm_tinNum1_PreviousSelected",
  iPSAppForm_bene_share1_PreviousSelected: "iPSAppForm_bene_share1_PreviousSelected",
  iPSAppForm_CHQ17_PreviousSelected: "iPSAppForm_CHQ17_PreviousSelected",
  iPSAppForm_bene_fname1_PreviousSelected: "iPSAppForm_bene_fname1_PreviousSelected",
  iPSAppForm_healthDec_treatment_PreviousSelected: "iPSAppForm_healthDec_treatment_PreviousSelected",
  iPSAppForm_bene_reln1_PreviousSelected: "iPSAppForm_bene_reln1_PreviousSelected",
  iPSAppForm_healthDec_otherDetails_PreviousSelected: "iPSAppForm_healthDec_otherDetails_PreviousSelected",
  iPSAppForm_bene_dob1_PreviousSelected: "iPSAppForm_bene_dob1_PreviousSelected",
  iPSAppForm_alcohol_years_PreviousSelected: "iPSAppForm_alcohol_years_PreviousSelected",
  iPSAppForm_trust_name1_PreviousSelected: "iPSAppForm_trust_name1_PreviousSelected",
  iPSAppForm_tin_country1_PreviousSelected: "iPSAppForm_tin_country1_PreviousSelected",
  iPSAppForm_myProfession_PreviousSelected: "iPSAppForm_myProfession_PreviousSelected",
  iPSAppForm_CHQ57_PreviousSelected: "iPSAppForm_CHQ57_PreviousSelected",
  iPSAppForm_trust_dob1_PreviousSelected: "iPSAppForm_trust_dob1_PreviousSelected",
  iPSAppForm_trust_city1_PreviousSelected: "iPSAppForm_trust_city1_PreviousSelected",
  iPSAppForm_CHQ58_PreviousSelected: "iPSAppForm_CHQ58_PreviousSelected",
  iPSAppForm_trust_pincode1_PreviousSelected: "iPSAppForm_trust_pincode1_PreviousSelected",
  iPSAppForm_CHQ39_PreviousSelected: "iPSAppForm_CHQ39_PreviousSelected",
  iPSAppForm_CHQ40_PreviousSelected: "iPSAppForm_CHQ40_PreviousSelected",
  iPSAppForm_HQ168_PreviousSelected: "iPSAppForm_HQ168_PreviousSelected",
  iPSAppForm_trust_address1_PreviousSelected: "iPSAppForm_trust_address1_PreviousSelected",
  iPSAppForm_trust_state1_PreviousSelected: "iPSAppForm_trust_state1_PreviousSelected",
  iPSAppForm_bene_fname2_PreviousSelected: "iPSAppForm_bene_fname2_PreviousSelected",
  iPSAppForm_country_PreviousSelected: "iPSAppForm_country_PreviousSelected",
  iPSAppForm_bene_dob2_PreviousSelected: "iPSAppForm_bene_dob2_PreviousSelected",
  iPSAppForm_travelInLast1Year_PreviousSelected: "iPSAppForm_travelInLast1Year_PreviousSelected",
  iPSAppForm_tin_country2_PreviousSelected: "iPSAppForm_tin_country2_PreviousSelected",
  iPSAppForm_purposeOfStay_PreviousSelected: "iPSAppForm_purposeOfStay_PreviousSelected",
  iPSAppForm_orgTypeDesc_PreviousSelected: "iPSAppForm_orgTypeDesc_PreviousSelected",
  iPSAppForm_add_bene2_PreviousSelected: "iPSAppForm_add_bene2_PreviousSelected",
  iPSAppForm_relationshipOthers_PreviousSelected: "iPSAppForm_relationshipOthers_PreviousSelected",
  iPSAppForm_tobacco_quantity_PreviousSelected: "iPSAppForm_tobacco_quantity_PreviousSelected",
  iPSAppForm_bene_reln2_PreviousSelected: "iPSAppForm_bene_reln2_PreviousSelected",
  iPSAppForm_tobacco_consumedAs_PreviousSelected: "iPSAppForm_tobacco_consumedAs_PreviousSelected",
  iPSAppForm_dateOfArrivingIndia_PreviousSelected: "iPSAppForm_dateOfArrivingIndia_PreviousSelected",
  iPSAppForm_CHQ44_PreviousSelected: "iPSAppForm_CHQ44_PreviousSelected",
  iPSAppForm_CHQ45_PreviousSelected: "iPSAppForm_CHQ45_PreviousSelected",
  iPSAppForm_HQ61_PreviousSelected: "iPSAppForm_HQ61_PreviousSelected",
  iPSAppForm_CHQ59_PreviousSelected: "iPSAppForm_CHQ59_PreviousSelected",
  iPSAppForm_CHQ46_PreviousSelected: "iPSAppForm_CHQ46_PreviousSelected",
  iPSAppForm_addPolicy2_PreviousSelected: "iPSAppForm_addPolicy2_PreviousSelected",
  iPSAppForm_addPolicy4_PreviousSelected: "iPSAppForm_addPolicy4_PreviousSelected",
  iPSAppForm_CHQ56_addCity1_PreviousSelected: "iPSAppForm_CHQ56_addCity1_PreviousSelected",
  iPSAppForm_CHQ60_PreviousSelected: "iPSAppForm_CHQ60_PreviousSelected",
  iPSAppForm_nationality_status_PreviousSelected: "iPSAppForm_nationality_status_PreviousSelected",
  iPSAppForm_city0_PreviousSelected: "iPSAppForm_city0_PreviousSelected",
  iPSAppForm_CHQ41_PreviousSelected: "iPSAppForm_CHQ41_PreviousSelected",
  iPSAppForm_nameOfCountry0_PreviousSelected: "iPSAppForm_nameOfCountry0_PreviousSelected",
  iPSAppForm_bene_share2_PreviousSelected: "iPSAppForm_bene_share2_PreviousSelected",
  iPSAppForm_otherReasonForNonBloodRelation_PreviousSelected:
    "iPSAppForm_otherReasonForNonBloodRelation_PreviousSelected",
  iPSAppForm_birth_country_PreviousSelected: "iPSAppForm_birth_country_PreviousSelected",
  iPSAppForm_tobacco_years_PreviousSelected: "iPSAppForm_tobacco_years_PreviousSelected",
  iPSAppForm_CHQ42_PreviousSelected: "iPSAppForm_CHQ42_PreviousSelected",
  iPSAppForm_appointeeRelationship_PreviousSelected: "iPSAppForm_appointeeRelationship_PreviousSelected",
  iPSAppForm_sum2_PreviousSelected: "iPSAppForm_sum2_PreviousSelected",
  iPSAppForm_appointeefrstNm_PreviousSelected: "iPSAppForm_appointeefrstNm_PreviousSelected",
  iPSAppForm_arrivalDate0_PreviousSelected: "iPSAppForm_arrivalDate0_PreviousSelected",
  iPSAppForm_orgNameDesc_PreviousSelected: "iPSAppForm_orgNameDesc_PreviousSelected",
  iPSAppForm_add_tin_country3_PreviousSelected: "iPSAppForm_add_tin_country3_PreviousSelected",
  iPSAppForm_tinNum2_PreviousSelected: "iPSAppForm_tinNum2_PreviousSelected",
  iPSAppForm_passportNo_PreviousSelected: "iPSAppForm_passportNo_PreviousSelected",
  iPSAppForm_countryOfResidence_PreviousSelected: "iPSAppForm_countryOfResidence_PreviousSelected",
  iPSAppForm_nameOfEmployer_PreviousSelected: "iPSAppForm_nameOfEmployer_PreviousSelected",
  iPSAppForm_trust_pancard1_PreviousSelected: "iPSAppForm_trust_pancard1_PreviousSelected",
  iPSAppForm_add_bene3_PreviousSelected: "iPSAppForm_add_bene3_PreviousSelected",
  iPSAppForm_dateOfLeavingIndia_PreviousSelected: "iPSAppForm_dateOfLeavingIndia_PreviousSelected",
  iPSAppForm_bene_dob3_PreviousSelected: "iPSAppForm_bene_dob3_PreviousSelected",
  iPSAppForm_bene_fname3_PreviousSelected: "iPSAppForm_bene_fname3_PreviousSelected",
  iPSAppForm_trust_mobileNo1_PreviousSelected: "iPSAppForm_trust_mobileNo1_PreviousSelected",
  iPSAppForm_bene_reln3_PreviousSelected: "iPSAppForm_bene_reln3_PreviousSelected",
  iPSAppForm_safetyPrecaution_PreviousSelected: "iPSAppForm_safetyPrecaution_PreviousSelected",
  iPSAppForm_trust_emailadd1_PreviousSelected: "iPSAppForm_trust_emailadd1_PreviousSelected",
  iPSAppForm_modeOfTravel_PreviousSelected: "iPSAppForm_modeOfTravel_PreviousSelected",
  iPSAppForm_natureOfBusiness_PreviousSelected: "iPSAppForm_natureOfBusiness_PreviousSelected",
  iPSAppForm_CHQ47_PreviousSelected: "iPSAppForm_CHQ47_PreviousSelected",
  iPSAppForm_CHQ43_addCity1_PreviousSelected: "iPSAppForm_CHQ43_addCity1_PreviousSelected",
  iPSAppForm_departureDate0_PreviousSelected: "iPSAppForm_departureDate0_PreviousSelected",
  iPSAppForm_addPolicy3_PreviousSelected: "iPSAppForm_addPolicy3_PreviousSelected",
  iPSAppForm_DurationAbroad_PreviousSelected: "iPSAppForm_DurationAbroad_PreviousSelected",
  iPSAppForm_sum3_PreviousSelected: "iPSAppForm_sum3_PreviousSelected",
  iPSAppForm_visaType0_PreviousSelected: "iPSAppForm_visaType0_PreviousSelected",
  iPSAppForm_bene_share3_PreviousSelected: "iPSAppForm_bene_share3_PreviousSelected",
  iPSAppForm_appointeeDob_PreviousSelected: "iPSAppForm_appointeeDob_PreviousSelected",
  iPSAppForm_add_travel_history1_PreviousSelected: "iPSAppForm_add_travel_history1_PreviousSelected",
  iPSAppForm_CHQ37_PreviousSelected: "iPSAppForm_CHQ37_PreviousSelected",
  iPSAppForm_CHQ51_PreviousSelected: "iPSAppForm_CHQ51_PreviousSelected",
  iPSAppForm_birth_city_PreviousSelected: "iPSAppForm_birth_city_PreviousSelected",
  iPSAppForm_CHQ55_PreviousSelected: "iPSAppForm_CHQ55_PreviousSelected",
  iPSAppForm_travel_history_PreviousSelected: "iPSAppForm_travel_history_PreviousSelected",
  iPSAppForm_HQ50_PreviousSelected: "iPSAppForm_HQ50_PreviousSelected",
  iPSAppForm_add_travel_in1_PreviousSelected: "iPSAppForm_add_travel_in1_PreviousSelected",
  iPSAppForm_HQ49_PreviousSelected: "iPSAppForm_HQ49_PreviousSelected",
  iPSAppForm_tin_country3_PreviousSelected: "iPSAppForm_tin_country3_PreviousSelected",
  iPSAppForm_bene_dob4_PreviousSelected: "iPSAppForm_bene_dob4_PreviousSelected",
  iPSAppForm_HQ53_PreviousSelected: "iPSAppForm_HQ53_PreviousSelected",
  iPSAppForm_bene_fname4_PreviousSelected: "iPSAppForm_bene_fname4_PreviousSelected",
  iPSAppForm_trust_mobileNo2_PreviousSelected: "iPSAppForm_trust_mobileNo2_PreviousSelected",
  iPSAppForm_HQ48_PreviousSelected: "iPSAppForm_HQ48_PreviousSelected",
  iPSAppForm_bene_reln4_PreviousSelected: "iPSAppForm_bene_reln4_PreviousSelected",
  iPSAppForm_healthDec_undergone_PreviousSelected: "iPSAppForm_healthDec_undergone_PreviousSelected",
  iPSAppForm_trust_emailadd2_PreviousSelected: "iPSAppForm_trust_emailadd2_PreviousSelected",
  iPSAppForm_HQ52_PreviousSelected: "iPSAppForm_HQ52_PreviousSelected",
  iPSAppForm_trust_address2_PreviousSelected: "iPSAppForm_trust_address2_PreviousSelected",
  iPSAppForm_bene_share4_PreviousSelected: "iPSAppForm_bene_share4_PreviousSelected",
  iPSAppForm_add_tin_country2_PreviousSelected: "iPSAppForm_add_tin_country2_PreviousSelected",
  iPSAppForm_purposeOfTravel_PreviousSelected: "iPSAppForm_purposeOfTravel_PreviousSelected",
  iPSAppForm_countryOfIssue_PreviousSelected: "iPSAppForm_countryOfIssue_PreviousSelected",
  iPSAppForm_HQ51_PreviousSelected: "iPSAppForm_HQ51_PreviousSelected",
  iPSAppForm_HQ54_PreviousSelected: "iPSAppForm_HQ54_PreviousSelected",
  iPSAppForm_countryOfBirth_PreviousSelected: "iPSAppForm_countryOfBirth_PreviousSelected",
  iPSAppForm_CHQ53_PreviousSelected: "iPSAppForm_CHQ53_PreviousSelected",
  iPSAppForm_dateOfLeavingIndia0_PreviousSelected: "iPSAppForm_dateOfLeavingIndia0_PreviousSelected",
  iPSAppForm_countryOfDestination0_PreviousSelected: "iPSAppForm_countryOfDestination0_PreviousSelected",
  iPSAppForm_nameOfCountry1_PreviousSelected: "iPSAppForm_nameOfCountry1_PreviousSelected",
  iPSAppForm_dateOfLeavingIndia1_PreviousSelected: "iPSAppForm_dateOfLeavingIndia1_PreviousSelected",
  iPSAppForm_departureDate1_PreviousSelected: "iPSAppForm_departureDate1_PreviousSelected",
  iPSAppForm_arrivalDate1_PreviousSelected: "iPSAppForm_arrivalDate1_PreviousSelected",
  iPSAppForm_countryOfDestination1_PreviousSelected: "iPSAppForm_countryOfDestination1_PreviousSelected",
  iPSAppForm_visaType1_PreviousSelected: "iPSAppForm_visaType1_PreviousSelected",
  iPSAppForm_add_travel_history2_PreviousSelected: "iPSAppForm_add_travel_history2_PreviousSelected",
  iPSAppForm_nameOfCountry2_PreviousSelected: "iPSAppForm_nameOfCountry2_PreviousSelected",
  iPSAppForm_countryOfDestination2_PreviousSelected: "iPSAppForm_countryOfDestination2_PreviousSelected",
  iPSAppForm_dateOfLeavingIndia2_PreviousSelected: "iPSAppForm_dateOfLeavingIndia2_PreviousSelected",
  iPSAppForm_departureDate2_PreviousSelected: "iPSAppForm_departureDate2_PreviousSelected",
  iPSAppForm_arrivalDate2_PreviousSelected: "iPSAppForm_arrivalDate2_PreviousSelected",
  iPSAppForm_CHQ54_PreviousSelected: "iPSAppForm_CHQ54_PreviousSelected",
  iPSAppForm_visaType2_PreviousSelected: "iPSAppForm_visaType2_PreviousSelected",
  iPSAppForm_HQ55_PreviousSelected: "iPSAppForm_HQ55_PreviousSelected",
  iPSAppForm_nameOfCountry3_PreviousSelected: "iPSAppForm_nameOfCountry3_PreviousSelected",
  iPSAppForm_countryOfDestination3_PreviousSelected: "iPSAppForm_countryOfDestination3_PreviousSelected",
  iPSAppForm_dateOfLeavingIndia3_PreviousSelected: "iPSAppForm_dateOfLeavingIndia3_PreviousSelected",
  iPSAppForm_departureDate3_PreviousSelected: "iPSAppForm_departureDate3_PreviousSelected",
  iPSAppForm_arrivalDate3_PreviousSelected: "iPSAppForm_arrivalDate3_PreviousSelected",
  iPSAppForm_CHQ52_PreviousSelected: "iPSAppForm_CHQ52_PreviousSelected",
  iPSAppForm_HQ56_PreviousSelected: "iPSAppForm_HQ56_PreviousSelected",
  iPSAppForm_visaType3_PreviousSelected: "iPSAppForm_visaType3_PreviousSelected",

  iPSAppForm_PersonalInfo_addCommunication: "iPSAppForm_PersonalInfo_addCommunication",
  iPSAppForm_PersonalInfo_appointeeDob: "iPSAppForm_PersonalInfo_appointeeDob",
  iPSAppForm_PersonalInfo_appointeefrstNm: "iPSAppForm_PersonalInfo_appointeefrstNm",
  iPSAppForm_PersonalInfo_appointeeRelationship: "iPSAppForm_PersonalInfo_appointeeRelationship",
  iPSAppForm_PersonalInfo_otherReasonForNonBloodRelation: "iPSAppForm_PersonalInfo_otherReasonForNonBloodRelation",
  iPSAppForm_PersonalInfo_relationshipOthers: "iPSAppForm_PersonalInfo_relationshipOthers",

  iPSAppForm_PersonalInfo_trust_type1: "iPSAppForm_PersonalInfo_trust_type1",
  iPSAppForm_PersonalInfo_trust_name1: "iPSAppForm_PersonalInfo_trust_name1",
  iPSAppForm_PersonalInfo_trust_address1: "iPSAppForm_PersonalInfo_trust_address1",
  iPSAppForm_PersonalInfo_trust_state1: "iPSAppForm_PersonalInfo_trust_state1",
  iPSAppForm_PersonalInfo_trust_city1: "iPSAppForm_PersonalInfo_trust_city1",
  iPSAppForm_PersonalInfo_trust_dob1: "iPSAppForm_PersonalInfo_trust_dob1",
  iPSAppForm_PersonalInfo_trust_pincode1: "iPSAppForm_PersonalInfo_trust_pincode1",
  iPSAppForm_PersonalInfo_trust_pancard1: "iPSAppForm_PersonalInfo_trust_pancard1",
  iPSAppForm_PersonalInfo_trust_emailadd1: "iPSAppForm_PersonalInfo_trust_emailadd1",
  iPSAppForm_PersonalInfo_trust_mobileNo1: "iPSAppForm_PersonalInfo_trust_mobileNo1",

  PaymentFrequency_6MonthsTo6Month: "PaymentFrequency_6MonthsTo6Month",
  PaymentFrequency_6MonthsTomonthly: "PaymentFrequency_6MonthsTomonthly",
  PaymentFrequency_6MonthsToyearly: "PaymentFrequency_6MonthsToyearly",
  PaymentFrequency_monthlyTo6Month: "PaymentFrequency_monthlyTo6Month",
  PaymentFrequency_monthlyTomonthly: "PaymentFrequency_monthlyTomonthly",
  PaymentFrequency_yearlyTo6Month: "PaymentFrequency_yearlyTo6Month",
  PaymentFrequency_yearlyTomonthly: "PaymentFrequency_yearlyTomonthly",
  PaymentFrequency_yearlyToyearly: "PaymentFrequency_yearlyToyearly",

  GetIncomeFor_Update: "GetIncomeFor_Update",
  MoneyBack_Yes: "MoneyBack_Yes",
  MoneyBack_No: "MoneyBack_No",
  IncomeStartsFrom_Update: "IncomeStartsFrom_Update",
  PayFor_Update: "PayFor_Update",
  MoneyBack: "MoneyBack_",
  YearSelected: "YearSelected",

  IncomeDate_Yes: "IncomeDate_Yes",
  IncomeDate_No: "IncomeDate_No",

  OptIncomeBooster_Yes: "OptIncomeBooster_Yes",
  OptIncomeBooster_No: "OptIncomeBooster_No",

  LimitedPay_10Yrs: "LimitedPay_10Yrs",
  LimitedPay_5Yrs: "LimitedPay_5Yrs",
  LimitedPay_7Yrs: "LimitedPay_7Yrs",

  iPSAppForm_doc_aadharBack_Captured: "iPSAppForm_doc_aadharBack_Captured",
  iPSAppForm_doc_aadharBack_CaptureSelected: "iPSAppForm_doc_aadharBack_CaptureSelected",
  iPSAppForm_doc_aadharBack_UploadSelected_Persona: "iPSAppForm_doc_aadharBack_UploadSelected_Persona",
  iPSAppForm_doc_aadharFront_CaptureSelected: "iPSAppForm_doc_aadharFront_CaptureSelected",
  iPSAppForm_doc_aadharFront_UploadSelected_Persona: "iPSAppForm_doc_aadharFront_UploadSelected_Persona",
  iPSAppForm_doc_DrivingLicense_Captured: "iPSAppForm_doc_DrivingLicense_Captured",
  iPSAppForm_doc_DrivingLicense_UploadSelected_Persona: "iPSAppForm_doc_DrivingLicense_UploadSelected_Persona",
  iPSAppForm_doc_panCard_UploadSelected_Persona: "iPSAppForm_doc_panCard_UploadSelected_Persona",
  iPSAppForm_doc_passFirst_UploadSelected_Persona: "iPSAppForm_doc_passFirst_UploadSelected_Persona",
  iPSAppForm_doc_passLast_UploadSelected_Persona: "iPSAppForm_doc_passLast_UploadSelected_Persona",
  iPSAppForm_doc_Photo_Captured: "iPSAppForm_doc_Photo_Captured",
  iPSAppForm_doc_Photo_CaptureSelected: "iPSAppForm_doc_Photo_CaptureSelected",
  iPSAppForm_doc_Photo_UploadSelected_Persona: "iPSAppForm_doc_Photo_UploadSelected_Persona",
  iPSAppForm_doc_slipPlusBank1_CaptureSelected: "iPSAppForm_doc_slipPlusBank1_CaptureSelected",
  iPSAppForm_doc_slipPlusBank1_UploadSelected_Persona: "iPSAppForm_doc_slipPlusBank1_UploadSelected_Persona",
  iPSAppForm_doc_slipPlusBank2_UploadSelected_Persona: "iPSAppForm_doc_slipPlusBank2_UploadSelected_Persona",
  iPSAppForm_doc_slipPlusBank3_UploadSelected_Persona: "iPSAppForm_doc_slipPlusBank3_UploadSelected_Persona",
  iPSAppForm_doc_slipPlusBank4_UploadSelected_Persona: "iPSAppForm_doc_slipPlusBank4_UploadSelected_Persona",
  iPSAppForm_doc_taxReturns1_UploadSelected_Persona: "iPSAppForm_doc_taxReturns1_UploadSelected_Persona",
  iPSAppForm_doc_taxReturns2_CaptureSelected: "iPSAppForm_doc_taxReturns2_CaptureSelected",
  "iPSAppForm_doc_Bank-statement_CaptureSelected": "iPSAppForm_doc_Bank-statement_CaptureSelected",
  iPSAppForm_doc_DrivingLicense_CaptureSelected: "iPSAppForm_doc_DrivingLicense_CaptureSelected",
  iPSAppForm_doc_PAN_CaptureSelected: "iPSAppForm_doc_PAN_CaptureSelected",
  iPSAppForm_doc_passFirst_CaptureSelected: "iPSAppForm_doc_passFirst_CaptureSelected",
  iPSAppForm_doc_passLast_CaptureSelected: "iPSAppForm_doc_passLast_CaptureSelected",
  iPSAppForm_doc_taxReturns1_CaptureSelected: "iPSAppForm_doc_taxReturns1_CaptureSelected",
  iPSAppForm_doc_taxReturns2_UploadSelected_Persona: "iPSAppForm_doc_taxReturns2_UploadSelected_Persona",
  iPSAppForm_doc_taxReturns3_UploadSelected_Persona: "iPSAppForm_doc_taxReturns3_UploadSelected_Persona",
  iPSAppForm_Document_aadharBack_Uploaded: "iPSAppForm_Document_aadharBack_Uploaded",
  iPSAppForm_Document_aadharFront_Uploaded: "iPSAppForm_Document_aadharFront_Uploaded",
  "iPSAppForm_doc_Bank-statement_UploadSelected_Persona": "iPSAppForm_doc_Bank-statement_UploadSelected_Persona",
  "iPSAppForm_doc_form16-1_CaptureSelected": "iPSAppForm_doc_form16-1_CaptureSelected",
  "iPSAppForm_doc_form16-1_UploadSelected_Persona": "iPSAppForm_doc_form16-1_UploadSelected_Persona",
  "iPSAppForm_doc_form16-2_UploadSelected_Persona": "iPSAppForm_doc_form16-2_UploadSelected_Persona",
  "iPSAppForm_Document_Bank-statement_Uploaded": "iPSAppForm_Document_Bank-statement_Uploaded",
  "iPSAppForm_Document_form16-1_Uploaded": "iPSAppForm_Document_form16-1_Uploaded",
  "iPSAppForm_Document_form16-2_Uploaded": "iPSAppForm_Document_form16-2_Uploaded",
  iPSAppForm_Document_License_Uploaded: "iPSAppForm_Document_License_Uploaded",
  iPSAppForm_Document_panCard_Uploaded: "iPSAppForm_Document_panCard_Uploaded",
  iPSAppForm_Document_passFirst_Uploaded: "iPSAppForm_Document_passFirst_Uploaded",
  iPSAppForm_Document_profile_Uploaded: "iPSAppForm_Document_profile_Uploaded",
  iPSAppForm_Document_slipPlusBank1_Uploaded: "iPSAppForm_Document_slipPlusBank1_Uploaded",
  iPSAppForm_Document_slipPlusBank2_Uploaded: "iPSAppForm_Document_slipPlusBank2_Uploaded",
  iPSAppForm_Document_slipPlusBank3_Uploaded: "iPSAppForm_Document_slipPlusBank3_Uploaded",
  iPSAppForm_Document_slipPlusBank4_Uploaded: "iPSAppForm_Document_slipPlusBank4_Uploaded",
  iPSAppForm_Document_taxReturns1_Uploaded: "iPSAppForm_Document_taxReturns1_Uploaded",
  iPSAppForm_Document_taxReturns2_Uploaded: "iPSAppForm_Document_taxReturns2_Uploaded",
  iPSAppForm_Document_taxReturns3_Uploaded: "iPSAppForm_Document_taxReturns3_Uploaded",
  iPSAppForm_Document_passLast_Uploaded: "iPSAppForm_Document_passLast_Uploaded",

  iPSAppForm_DocumentUpload_Started: "iPSAppForm_DocumentUpload_Started",

  LocAdhaarNo_PopupClose: "LocAdhaarNo_PopupClose",
  LocAdhaarNo_PopupOpen: "LocAdhaarNo_PopupOpen",

  iPSAppForm_doc_AddressProof_Adhr_Selected: "iPSAppForm_doc_AddressProof_Adhr_Selected",
  iPSAppForm_doc_AddressProof_Driving_License_Selected: "iPSAppForm_doc_AddressProof_Driving_License_Selected",
  iPSAppForm_doc_AddressProof_Passport_Selected: "iPSAppForm_doc_AddressProof_Passport_Selected",
  iPSAppForm_doc_AddressProof_Voters_ID_Selected: "iPSAppForm_doc_AddressProof_Voters_ID_Selected",

  iPSAppForm_doc_aadharBack_Retake: "iPSAppForm_doc_aadharBack_Retake",
  iPSAppForm_doc_aadharFront_Retake: "iPSAppForm_doc_aadharFront_Retake",
  iPSAppForm_doc_DrivingLicense_Retake: "iPSAppForm_doc_DrivingLicense_Retake",
  "iPSAppForm_doc_form16-1_Retake": "iPSAppForm_doc_form16-1_Retake",
  iPSAppForm_doc_PAN_Retake: "iPSAppForm_doc_PAN_Retake",
  iPSAppForm_doc_Photo_Retake: "iPSAppForm_doc_Photo_Retake",

  iPSAppForm_doc_aadharFront_Captured: "iPSAppForm_doc_aadharFront_Captured",
  "iPSAppForm_doc_form16-1_Captured": "iPSAppForm_doc_form16-1_Captured",
  iPSAppForm_doc_PAN_Captured: "iPSAppForm_doc_PAN_Captured",
  iPSAppForm_doc_passFirst_Captured: "iPSAppForm_doc_passFirst_Captured",
  iPSAppForm_doc_passLast_Captured: "iPSAppForm_doc_passLast_Captured",

  iPSAppForm_doc_aadharBack_CaptureClosed: "iPSAppForm_doc_aadharBack_CaptureClosed",
  iPSAppForm_doc_aadharFront_CaptureClosed: "iPSAppForm_doc_aadharFront_CaptureClosed",
  iPSAppForm_doc_AddressProof_Example_Selected: "iPSAppForm_doc_AddressProof_Example_Selected",
  "iPSAppForm_doc_Bank-statement_CaptureClosed": "iPSAppForm_doc_Bank-statement_CaptureClosed",
  iPSAppForm_doc_DrivingLicense_CaptureClosed: "iPSAppForm_doc_DrivingLicense_CaptureClosed",
  "iPSAppForm_doc_form16-1_CaptureClosed": "iPSAppForm_doc_form16-1_CaptureClosed",
  iPSAppForm_doc_PAN_CaptureClosed: "iPSAppForm_doc_PAN_CaptureClosed",
  iPSAppForm_doc_PAN_Example_Selected: "iPSAppForm_doc_PAN_Example_Selected",
  iPSAppForm_doc_Photo_CaptureClosed: "iPSAppForm_doc_Photo_CaptureClosed",
  iPSAppForm_doc_slipPlusBank1_CaptureClosed: "iPSAppForm_doc_slipPlusBank1_CaptureClosed",
  iPSAppForm_doc_taxReturns2_CaptureClosed: "iPSAppForm_doc_taxReturns2_CaptureClosed",

  WhatsAppQuote_Selected: "WhatsAppQuote_Selected",

  iPSAppForm_PersonalInfo_add_bene1: "iPSAppForm_PersonalInfo_add_bene1",
  iPSAppForm_PersonalInfo_add_bene2: "iPSAppForm_PersonalInfo_add_bene2",
  iPSAppForm_PersonalInfo_add_bene3: "iPSAppForm_PersonalInfo_add_bene3",
  iPSAppForm_PersonalInfo_add_bene4: "iPSAppForm_PersonalInfo_add_bene4",
  iPSAppForm_PersonalInfo_add_bene5: "iPSAppForm_PersonalInfo_add_bene5",

  iPSAppForm_PersonalInfo_address3: "iPSAppForm_PersonalInfo_address3",

  iPSAppForm_PersonalInfo_country_nationality: "iPSAppForm_PersonalInfo_country_nationality",
  iPSAppForm_PersonalInfo_country_nationality_fn: "iPSAppForm_PersonalInfo_country_nationality_fn",
  iPSAppForm_PersonalInfo_countryOfResidence_fn: "iPSAppForm_PersonalInfo_countryOfResidence_fn",
  iPSAppForm_PersonalInfo_dateOfArrivingIndia_fn: "iPSAppForm_PersonalInfo_dateOfArrivingIndia_fn",
  iPSAppForm_PersonalInfo_dateOfLeavingIndia_fn: "iPSAppForm_PersonalInfo_dateOfLeavingIndia_fn",
  iPSAppForm_PersonalInfo_DurationAbroad: "iPSAppForm_PersonalInfo_DurationAbroad",
  iPSAppForm_PersonalInfo_DurationAbroad_month_fn: "iPSAppForm_PersonalInfo_DurationAbroad_month_fn",
  iPSAppForm_PersonalInfo_feet: "iPSAppForm_PersonalInfo_feet",
  iPSAppForm_PersonalInfo_IntendedAbroad: "iPSAppForm_PersonalInfo_IntendedAbroad",
  iPSAppForm_PersonalInfo_IntendedAbroad_month: "iPSAppForm_PersonalInfo_IntendedAbroad_month",
  iPSAppForm_PersonalInfo_isThirdPartyPayment: "iPSAppForm_PersonalInfo_isThirdPartyPayment",
  iPSAppForm_PersonalInfo_nameOfEmployer_fn: "iPSAppForm_PersonalInfo_nameOfEmployer_fn",
  iPSAppForm_PersonalInfo_nri_intended_duration: "iPSAppForm_PersonalInfo_nri_intended_duration",
  iPSAppForm_PersonalInfo_nri_stay_abroad_duration: "iPSAppForm_PersonalInfo_nri_stay_abroad_duration",
  iPSAppForm_PersonalInfo_nri_stay_abroad_duration_fn: "iPSAppForm_PersonalInfo_nri_stay_abroad_duration_fn",
  iPSAppForm_PersonalInfo_country: "iPSAppForm_PersonalInfo_country",
  FormInformation_PopupClose: "FormInformation_PopupClose",
  FormInformation_PopupOpen: "FormInformation_PopupOpen",
  FormInformation_Selected: "FormInformation_Selected",
  QuickGuide_TermPlan: "QuickGuide_TermPlan",
  QuickGuide_AdditionalBenefits: "QuickGuide_AdditionalBenefit",
  QuickGuide_TermPlanCalculator: "QuickGuide_TermPlanCalculator",
  ViewBreakup_PopupOpen: "ViewBreakup_PopupOpen",
  ViewBreakup_clicked: "ViewBreakup_clicked",
  Back_Selected: "Back_Selected",
  TermPlan_CheckPremium: "TermPlan_CheckPremium",
  AdditionalBenefits_CheckPremium: "AdditionalBenefits_CheckPremium",
  TermPlanCalculator_CheckPremium: "TermPlanCalculator_CheckPremium",
  ViewBreakup_close: "ViewBreakup_close",
  AdditionalBenefits_Backward: "AdditionalBenefits_Backward",
  AdditionalBenefits_Forward: "AdditionalBenefits_Forward",
  TermPlan_Backward: "TermPlan_Backward",
  TermPlan_Forward: "TermPlan_Forward",
  TermPlanCalculator_Forward: "TermPlanCalculator_Forward",
  TermPlanCalculator_Backward: "TermPlanCalculator_Backward",
  PlanRecommended_Next: "PlanRecommended_Next",
  PlanRecommended_Previous: "PlanRecommended_Previous",
  tenthThingsAnnuity_Next: "10thingsAnnuity_Next",
  tenthThingsAnnuity_Previous: "10thingsAnnuity_Previous",
  SignatureBenefits_ViewBenefits: "SignatureBenefits_ViewBenefits",
  SignatureBenefits_Selected: "SignatureBenefits_Selected",
  SignatureBenefits_PopupOpen: "SignatureBenefits_PopupOpen",
  SignatureBenefits_CheckReturns: "SignatureBenefits_CheckReturns",
  SignatureBenefits_PopupClose: "SignatureBenefits_PopupClose",
  SignatureBenefits_HideBenefits: "SignatureBenefits_HideBenefits",
  SignatureBenefits_Next: "SignatureBenefits_Next",
  SignatureBenefits_Previous: "SignatureBenefits_Previous",
  MythBusters_Selected: "MythBusters_Selected",
  MythBusters_PopupOpen: "MythBusters_PopupOpen",
  MythBusters_Next: "MythBusters_Next",
  MythBusters_Previous: "MythBusters_Previous",
  MythBusters_PopupClose: "MythBusters_PopupClose",
  MythBusters_CalculateReturns: "MythBusters_CalculateReturns",
  FundPerformance_ViewAll: "FundPerformance_ViewAll",
  FundPerformance_OptionSelected: "FundPerformance_OptionSelected",
  DidYouKnow_Next: "DidYouKnow_Next",
  DidYouKnow_Previous: "DidYouKnow_Previous",
  KeyTerminology_Selected: "KeyTerminology_Selected",
  KeyTerminology_Next: "KeyTerminology_Next",
  KeyTerminology_Previous: "KeyTerminology_Previous",
  KeyTerminology_Shown: "KeyTerminology_Shown",
  SuitabilityAnalysis_clicked: "SuitabilityAnalysis_clicked",
  SuitabilityCalculator_close: "SuitabilityCalculator_close",
  SuitabilityAnalysis_PopupOpen: "SuitabilityAnalysis_PopupOpen",
  SuitabilityCalculator_AnalysisSubmit: "SuitabilityCalculator_close",
  LifeCover_Edit: "LifeCover_Edit",
  LifeCover_Updated: "LifeCover_Updated",
  CoverTillAge_Edit: "CoverTillAge_Edit",
  Payementterm_Selected: "Payementterm_Selected",
  Payementterm_Next: "Payementterm_Next",
  Payementterm_Previous: "Payementterm_Previous",
  NomineeRecived: "NomineeRecived",
  NomineeRecived_Next: "NomineeRecived_Next",
  ImpDocument_required: "ImpDocument_required",
  ImpDocument_List_Download: "ImpDocument_List_Download",
  NomineeRecived_Previous: "NomineeRecived_Previous",
  TaxSaving_Selected: "TaxSaving_Selected",
  TaxSaving_PopupOpen: "TaxSaving_PopupOpen",
  TaxSaving_SaveTax: "TaxSaving_SaveTax",
  TaxSaving_OkGotIt: "TaxSaving_OkGotIt",
  TaxSaving_PopupClose: "TaxSaving_PopupClose",
  FundPerformance_Selected: "FundPerformance_Selected",
  FundPerformance_PopupOpen: "FundPerformance_PopupOpen",
  FundPerformance_PopupClose: "FundPerformance_PopupClose",
  FundPerformance_GotIt: "FundPerformance_GotIt",
  EditFundAllocation_Selected: "EditFundAllocation_Selected",
  EditFundAllocation_Open: "EditFundAllocation_Open",
  EditFundAllocation_Close: "EditFundAllocation_Close",
  FundAllocationType_Selected: "FundAllocationType_Selected",
  FundAllocation_All: "FundAllocation_All",
  FundAllocation_Equity: "FundAllocation_Equity",
  FundAllocation_Balanced: "FundAllocation_Balanced",
  FundAllocation_Debt: "FundAllocation_Debt",
  FundAllocation_ViewFundSummary: "FundAllocation_ViewFundSummary",
  FundSummary_PopupOpen: "FundSummary_PopupOpen",
  FundSummary_PopupClose: "FundSummary_PopupClose",
  FundSummary_Proceed: "FundSummary_Proceed",
  AutomaticFundTransfer_Yes: "AutomaticFundTransfer_Yes",
  AutomaticFundTransfer_No: "AutomaticFundTransfer_No",
  RegularWithdrawal_Now: "RegularWithdrawal_Now",
  RegularWithdrawal_Later: "RegularWithdrawal_Later",
  FundAllocation_DefaultSettings: "FundAllocation_DefaultSettings",
  FundAllocation_Save: "FundAllocation_Save",
  EBI_Downloaded: "EBI_Downloaded",
  AskLiGo_PopupClose: "AskLiGo_PopupClose",
  AskLiGo_PopupOpen: "AskLiGo_PopupOpen",
  AskLiGo_Selected: "AskLiGo_Selected",
  AskLiGo_Restart: "AskLiGo_Restart",
  AskLiGo_QuestionSelected: "AskLiGo_QuestionSelected",
  AskLiGo_SearchClicked: "AskLiGo_SearchClicked",
  AskLiGo_SearchQuestion: "AskLiGo_SearchQuestion",
  ExitIntent_PopupOpen: "ExitIntent_PopupOpen",
  ExitIntent_PopupClose: "ExitIntent_PopupClose",
  SaveMoneyNow_Selected: "SaveMoneyNow_Selected",
  IWantPayMore_Selected: "IWantPayMore_Selected",
  Benefits_Selected: "Benefits_Selected",
  HowThePlanWorks_Selected: "HowThePlanWorks_Selected",
  FAQs_Clicked: "FAQs_Clicked",
  WhyInvestULIP_PopupClose: "WhyInvestULIP_PopupClose",
  WhyInvestULIP_Selected: "WhyInvestULIP_Selected",
  WhyInvestULIP_PopupOpen: "WhyInvestULIP_PopupOpen",
  ARR_4_Selected: "ARR_4%Selected",
  ARR_8_Selected: "ARR_8%Selected",
  PastPerformance_1Y: "PastPerformance_1Y",
  PastPerformance_3Y: "PastPerformance_3Y",
  PastPerformance_5Y: "PastPerformance_5Y",
  SelectFund_DropDown: "SelectFund_DropDown",
  AddOnRider_Selected: "AddOnRider_Selected",
  AddOnRider_PopupOpen: "AddOnRider_PopupOpen",
  AddOnRider_PopupClose: "AddOnRider_PopupClose",
  AdditionalAddOn_Selected: "AdditionalAddOn_Selected",
  AddOnRider_WaiverOfPremium_Selected: "AddOnRider_WaiverOfPremium_Selected",
  AddOnRider_WaiverOfPremium_Remove: "AddOnRider_WaiverOfPremium_Remove",
  AddOnRider_Edit: "AddOnRider_Edit",
  Floating_CheckReturn: "Floating_CheckReturn",
  AppForm_EC_PopUpOpen: "AppForm_EC_PopUpOpen",
  AppForm_EC_PhoneNumber_confirm: "AppForm_EC_PhoneNumber_confirm",
  AppForm_EC_OTP_PopUpOpen: "AppForm_EC_OTP_PopUpOpen",
  AppForm_EC_OTP_Verified: "AppForm_EC_OTP_Verified",
  AppForm_EC_OTP_NotVerified: "AppForm_EC_OTP_NotVerified",
  AppForm_EC_OTP_Resend: "AppForm_EC_OTP_Resend",
  AppForm_EC_OTP_Cancel: "AppForm_EC_OTP_Cancel",
  AppForm_EC_PopUpclose: "AppForm_EC_PopUpclose",
  AppForm_EC_OTP_PopUpClose: "AppForm_EC_OTP_PopUpClose",
  AppForm_Landed: "AppForm_Landed",
  AppForm_Review_Landed: "AppForm_Review_Landed",
  AppForm_PersonalDetails_Completed: "AppForm_PersonalDetails_Completed",
  AppForm_OtherPolicy_Yes: "AppForm_OtherPolicy_Yes",
  AppForm_OtherPolicy_No: "AppForm_OtherPolicy_No",
  AppForm_AddAnotherPolicy_Selected: "AppForm_AddAnotherPolicy_Selected",
  AppForm_AddAnotherPolicy_Close: "AppForm_AddAnotherPolicy_Close",
  AppForm_HealthDetails_Started: "AppForm_HealthDetails_Started",
  AppForm_HealthDetails_Question: "AppForm_HealthDetails_Question",
  AppForm_PayoutDetails_Selected: "AppForm_PayoutDetails_Selected",
  AppForm_HealthDetails_Completed: "AppForm_HealthDetails_Completed",
  AppForm_PayoutDetails_Started: "AppForm_PayoutDetails_Started",
  AppForm_PayoutDetails_ClickHere: "AppForm_PayoutDetails_ClickHere",
  AppForm_AccDetails_PopUpOpen: "AppForm_AccDetails_PopUpOpen",
  AppForm_AccDetails_cheque_next: "AppForm_AccDetails_cheque_next",
  AppForm_AccDetails_PassBook_next: "AppForm_AccDetails_PassBook_next",
  AppForm_AccDetails_PassBook_Back: "AppForm_AccDetails_PassBook_Back",
  AppForm_AccDetails_NetBanking_Back: "AppForm_AccDetails_NetBanking_Back",
  AppForm_AccDetails_PopUpClose: "AppForm_AccDetails_PopUpClose",
  AppForm_PayoutDetails_CancelCheque: "AppForm_PayoutDetails_CancelCheque",
  AppForm_PayoutDetails_CancelCheque_Open: "AppForm_PayoutDetails_CancelCheque_Open",
  AppForm_PayoutDetails_CancelCheque_Close: "AppForm_PayoutDetails_CancelCheque_Close",
  AppForm_ApplicationSummary_Landed: "AppForm_ApplicationSummary_Landed",
  AppForm_DocumentUploadSelected: "AppForm_DocumentUploadSelected",
  AppForm_ProceedToPayment: "AppForm_ProceedToPayment",
  AppForm_PoliticallyExposedPerson_Edit: "AppForm_PoliticallyExposedPerson_Edit",
  AppForm_CriminalCivilOffenceRecord_Edit: "AppForm_Criminal/CivilOffenceRecord_Edit",
  AppForm_ThirdPartyPayment_Edit: "AppForm_ThirdPartyPayment_Edit",
  AppForm_eIA_Edit: "AppForm_eIA_Edit",
  AppForm_HealthDetails_Edit: "AppForm_HealthDetails_Edit",
  AppForm_PayoutDetails_Edit: "AppForm_PayoutDetails_Edit",
  AppForm_Nominee_Edit: "AppForm_Nominee_Edit",
  AppForm_BasicInformation_Edit: "AppForm_BasicInformation_Edit",
  AppForm_ContactDetails_Edit: "AppForm_ContactDetails_Edit",
  AppForm_PreviousPolicyDetails_Edit: "AppForm_PreviousPolicyDetails_Edit",
  AppForm_ProposerDetails_Edit: "AppForm_ProposerDetails_Edit",
  AppForm_ProposerContactDetails_Edit: "AppForm_ProposerContactDetails_Edit",
  AppForm_FATCA_Edit: "AppForm_FATCA_Edit",
  AppForm_StayDetails_Edit: "AppForm_StayDetails_Edit",
  AppForm_NriTravelDetails_Edit: "AppForm_NriTravelDetails_Edit",
  AppForm_LifeAssuredCommunicationDetails_Edit: "AppForm_LifeAssuredCommunicationDetails_Edit",
  AppForm_Mwpa_Edit: "AppForm_Mwpa_Edit",
  AppForm_LaStayDetails_Edit: "AppForm_LaStayDetails_Edit",
  AppForm_TCAccepted: "AppForm_T&CAccepted",
  AppForm_PersonalDetails_Back: "AppForm_PersonalDetails_Back",
  AppForm_HealthDetails_Back: "AppForm_HealthDetails_Back",
  AppForm_PayoutDetails_Back: "AppForm_PayoutDetails_Back",

  SpouseDetails_Saved: "SpouseDetails_Saved",
  Spouse_LifeCoverEdit: "Spouse_LifeCoverEdit",
  SpouseCover_AddOnSelected: "SpouseCover_AddOnSelected",
  SpouseCriticalIllness_AddOnSelected: "SpouseCriticalIllness_AddOnSelected",
  SpouseAccidentalDeath_AddOnSelected: "SpouseAccidentalDeath_AddOnSelected",
  SpouseCriticalIllness_AddOnedited: "SpouseCriticalIllness_AddOnedited",
  SpouseAccidentalDeath_AddOnedited: "SpouseAccidentalDeath_AddOnedited",
  SpousePaymentTerm_Selected: "SpousePaymentTerm_Selected",
  IPS_aadhar_getotp: "IPS_aadhar_getotp",
  iPSAppForm_OccupationDetails_Completed: "iPSAppForm_OccupationDetails_Completed",
  iPSAppForm_NomineeDetails_Completed: "iPSAppForm_NomineeDetails_Completed",
  iPSAppForm_HealthDetails_Started: "iPSAppForm_HealthDetails_Started",
  iPSAppForm_HealthDetails_Completed: "iPSAppForm_HealthDetails_Completed",
  IPS_aadhar_getOtp: "IPS_aadhar_getOtp",
  IPS_View_fullBreakup: "IPS_View_fullBreakup",
  IPS_Hide_fullBreakup: "IPS_Hide_fullBreakup",
  BackQuotePage: "BackQuotePage",
  iPSAppForm_EditOccupation: "iPSAppForm_EditOccupation",
  iPSAppForm_HealthDetails_Question: "iPSAppForm_HealthDetails_Question",
  AppForm_PersonalDetails_Question: "AppForm_PersonalDetails_Question",
  IPS_Claimratio_checkdocument: "IPS_Claimratio_checkdocument",
  ViewFullVideo_Selected: "ViewFullVideo_Selected",
  RoyStory_Clicked: "RoyStory_Clicked",
  "Satish'sStory_Clicked": "Satish'sStory_Clicked",
  "Sunil'sStory_Clicked": "Sunil'sStory_Clicked",
  "Rohit'sStory_Clicked": "Rohit'sStory_Clicked",
  IBM_PopupOpen: "IBM_PopupOpen",
  IBM_CheckPlans_Selected: "IBM_CheckPlans_Selected",
  ASK_LIGO_SELECTED: "AskLiGo_Selected",
  ASK_LIGO_POPUP_OPEN: "AskLiGo_PopupOpen",
  SETLEMENT_RATIO_CLICK: "ClaimSettlementRatio_Click",
  CLAIM_ASSURANCE_CLICK: "ClaimAssurance_IconClick",
  LowPremiumgarentee_KnowMore: "LowPremiumgarentee_KnowMore",
  LowPremiumgarentee_KnowMoreOK: "LowPremiumgarentee_KnowMoreOK",
  ExpertAdvice_ScheduleCall: "ExpertAdvice_ScheduleCall",
  ExpertAdvice_ScheduleCall_PopupOpen: "ExpertAdvice_ScheduleCall_PopupOpen",
  NeedHelp_PopupOpen: "NeedHelp_PopupOpen",
  ExpertAdvice_ScheduleCall_PopupClose: "ExpertAdvice_ScheduleCall_PopupClose",
  NeedHelp_PopupClose: "NeedHelp_PopupClose",
  ExpertAdvice_ScheduleCall_Confirm: "ExpertAdvice_ScheduleCall_Confirm",
  NeedHelp_CallMeNow: "NeedHelp_CallMeNow",
  NeedHelp_Schedule: "NeedHelp_Schedule",
  ClaimsCorner_DownloadDoc: "ClaimsCorner_DownloadDoc",
  CICover_60: "CICover_60",
  CICover_20: "CICover_20",
  Schedule_OkGot_it: "Schedule_OkGot_it",
  SchecduleAppointment: "SchecduleAppointment",
  ReSchecduleAppointment: "ReSchecduleAppointment",
  NeedHelp_Reschedule: "NeedHelp_Reschedule",
  Appointment_AddOncalender: "Appointment_AddOncalender",
  NeedHelp_AddtoCalender: "NeedHelp_AddtoCalender",
  Schedule_callPopupOpen: "Schedule_callPopupOpen",
  Schedule_callPopupClose: "Schedule_callPopupClose",
  DILC_CheckPremium: "DILC_CheckPremium",
  FP_CheckPremium: "FP_CheckPremium",
  ThingsBeforeBuy_Optionselected: "ThingsBeforeBuy_Optionselected",
  ThingsBeforeBuy_Next: "ThingsBeforeBuy_Next",
  ThingsBeforeBuy_Previous: "ThingsBeforeBuy_Previous",
  ipstosuper_popup_open: "ipstosuper_popup_open",
  ipstosuper_popup_close: "ipstosuper_popup_close",
  ipstosuper_check_premium: "ipstosuper_check_premium",
  ipstosaraljeevan_popup_open: "ipstosaraljeevan_popup_open",
  ipstosaraljeevan_popup_close: "ipstosaraljeevan_popup_close",
  ipstosaraljeevan_check_premium: "ipstosaraljeevan_check_premium",
  ipstoother_plan_popup_open: "ipstoother_plan_popup_open",
  ipstoother_plan_popup_close: "ipstoother_plan_popup_close",
  ipstoother_plan_check_premium: "ipstoother_plan_check_premium",
  DILC_Selected: "DILC_Selected",
  FP_selected: "FP_selected",
  KnowTermPlan40Sec_VideoClick: "KnowTermPlan40Sec_VideoClick",
  KnowTermPlan40Sec_VideoClose: "KnowTermPlan40Sec_VideoClose",
  eKyc_ProceedwithAdhaar_Selected: "eKyc_ProceedwithAdhaar_Selected",
  eKyc_ProceedwithAdhaar_GetOTP: "eKyc_ProceedwithAdhaar_GetOTP",
  eKyc_Adhaar_OTP_Resend: "eKyc_Adhaar_OTP_Resend",
  eKyc_Adhaar_OTP_Submit: "eKyc_Adhaar_OTP_Submit",
  eKyc_TC_Popupopen: "eKyc_T&C_Popupopen",
  eKyc_TC_PopupClose: "eKyc_T&C_PopupClose",
  eKyc_TCAccepted_EKYC: "eKyc_T&CAccepted",
  eKyc_TC_LangSwitch: "eKyc_T&C_LangSwitch",
  DOB_error_PopupOpen: "DOB_error_PopupOpen",
  DOB_error_PopupClose: "DOB_error_PopupClose",
  DOB_error_RecalculateQuote: "DOB_error_RecalculateQuote",
  DOB_error_GeneratedQuote: "DOB_error_GeneratedQuote",
  AdhaarDet_PopupOpen: "AdhaarDet_PopupOpen",
  AdhaarDet_PopupClose: "AdhaarDet_PopupClose",
  AdhaarDet_Continue_Clicked: "AdhaarDet_Continue_Clicked",
  AdhaarDet_FillAppfromManually_Clicked: "AdhaarDet_FillAppfromManually_Clicked",
  eKyc_error_popup: "eKyc_error_popup",
  eKyc_error_popup_FillAppfromManually_Clicked: "eKyc_error_popup_FillAppfromManually_Clicked",
  Addons_Checkbox_Click: "Addons_Checkbox_Click",
  Addons_Cover_Edit: "Addons_Cover_Edit",
  _Supportteam_Selected: "24/7_Supportteam_Selected",
  _Supportteam_PopupOpen: "24/7_Supportteam_PopupOpen",
  _Supportteam_PopupClose: "24/7_Supportteam_PopupClose",
  Calculatepremium_PopupOpen: "Calculatepremium_PopupOpen",
  Calculatepremium_PopupClose: "Calculatepremium_PopupClose",
  PlanFitsFor_Salaried: "PlanFitsFor_Salaried",
  PlanFitsFor_SelfEmployed: "PlanFitsFor_SelfEmployed",
  PlanFitsFor_WorkingWomen: "PlanFitsFor_WorkingWomen",
  PlanFitsFor_Housewife: "PlanFitsFor_Housewife",
  PlanFitsFor_NRI: "PlanFitsFor_NRI",
  PlanFitsFor_Next: "PlanFitsFor_Next",
  PlanFitsFor_Previous: "PlanFitsFor_Previous",
  ProceedwithoutAdhaar_PopupOpen: "ProceedwithoutAdhaar_PopupOpen",
  ProceedwithoutAdhaar_PopupClose: "ProceedwithoutAdhaar_PopupClose",
  ProceedwithoutAdhaar_ContinuewithAdhardet: "ProceedwithoutAdhaar_ContinuewithAdhardet",
  CheckAllFunds_Clicked: "CheckAllFunds_Clicked",
  PlanSnapshot_Goalprotection: "PlanSnapshot_Goalprotection",
  PlanSnapshot_WealthCreation: "PlanSnapshot_WealthCreation",
  Taxbenefitillustration_Selected: "Taxbenefitillustration_Selected",
  Taxbenefitillustration_PopupOpen: "Taxbenefitillustration_PopupOpen",
  Taxbenefitillustration_PopupClose: "Taxbenefitillustration_PopupClose",
  Taxbenefitillustration_CheckPremium: "Taxbenefitillustration_CheckPremium",
  StepToBuy_Selected: "StepToBuy_Selected",
  EkycPage_Landed: "EkycPage_Landed",
  ProceedToPayment: "ProceedToPayment",
  AppForm_PersonalInfo_Started: "AppForm_PersonalInfo_Started",
  GST_POPUP_OPEN: "GST_Popup_Open",
  GST_POPUP_CLOSE: "GST_Popup_Close",
  GST_CHECKBOX_SELECTED: "GST_Declaration_Checkbox_Selected",
  GST_CTA_PROCEED: "GST_Popup_Proceed",
  GST_Popup_Open: "GST_Popup_Open",
  GST_Popup_Close: "GST_Popup_Close",
  GST_Declaration_Checkbox_Selected: "GST_Declaration_Checkbox_Selected",
  GST_Popup_Proceed: "GST_Popup_Proceed",
  AppForm_IIB_Yes: "AppForm_IIB_Yes",
  AppForm_IIB_PopupOpen: "AppForm_IIB_PopupOpen",
  AppForm_IIB_PopupClose: "AppForm_IIB_PopupClose",
  AppForm_IIB_Question1_Yes: "AppForm_IIB_Question1_Yes",
  AppForm_IIB_Question1_No: "AppForm_IIB_Question1_No",
  AppForm_IIB_Question2_Yes: "AppForm_IIB_Question2_Yes",
  AppForm_IIB_Question2_No: "AppForm_IIB_Question2_No",
  AppForm_IIB_Submit: "AppForm_IIB_Submit",
  AppForm_IIB_Success_PopupOpen: "AppForm_IIB_Success_PopupOpen",
  AppForm_IIB_Success_PopupClose: "AppForm_IIB_Success_PopupClose",
  AppForm_IIB_UnableToFetchPolicy: "AppForm_IIB_UnableToFetchPolicy",
  OTC_Appform_Proceed: "OTC_Appform_Proceed",
  OTC_Review_Proceed: "OTC_Review_Proceed",
  OTC_Declaration_Iagree: "OTC_Declaration_Iagree",
  OTC_Declaration_PopupOpen: "OTC_Declaration_PopupOpen",
  OTC_Declaration_PopupClose: "OTC_Declaration_PopupClose",

  Welcome_Kit_Checked: "Welcome_Kit_Checked",
  Welcome_Kit_Unchecked: "Welcome_Kit_Unchecked",
  Return_QuoteSeen: "Return_QuoteSeen",
  OTC_Edit: "OTC_Edit",
  OTC_Prev: "OTC_Prev",
  Assure_SIP_PopupOpen: "Assure_SIP_PopupOpen",
  Assure_SIP_PopupClose: "Assure_SIP_PopupClose",
  Switch_SIP_Button: "Switch_SIP_Button",
  Continue_Plan_Button: "Continue_Plan_Button",
  Hindi_Selected: "Hindi_Selected",
  English_Selected: "English_Selected",
  Marathi_Selected: "Marathi_Selected",
  Telugu_Selected: "Telugu_Selected",
  Tamil_Selected: "Tamil_Selected",
  Kannada_Selected: "Kannada_Selected",
  PastReturns: "PastReturns",
  FundPerformance_fundfacts_download: "FundPerformance_fundfacts_download",
  plan_Selected: "plan_Selected",
  ResumeYourJourney_Edit: "ResumeYourJourney_Edit",
  ResumeYourJourney_PopupOpen: "ResumeYourJourney_PopupOpen",
  ResumeYourJourney_CalculatePremiumPopupOpen: "ResumeYourJourney_CalculatePremiumPopupOpen",
  ResumeYourJourney_CalculatePremiumPopupClose: "ResumeYourJourney_CalculatePremiumPopupClose",
  ResumeYourJourney_CalculatePremium: "ResumeYourJourney_CalculatePremium",
  Edit_Info: "Edit_Info",
  Edit_PopupOpen: "Edit_PopupOpen",
  SaveUpdate_Info: "SaveUpdate_Info",
  Edit_PopupClose: "Edit_PopupClose",
  Preferred_Language_Selected: "Language_Selected",
  NFO_Opt: "NFO_Opt",
  NFO_Opt_Popup_Open: "NFO_Opt_Popup_Open",
  NFO_Opt_Popup_Close: "NFO_Opt_Popup_Close",
  NFO_Opt_Edit: "NFO_Opt_Edit",
  NFO_Opt_Cancel: "NFO_Opt_Cancel",
  NFO_Opt_Checkbox: "NFO_Opt_Checkbox",
  NFO_Opt_Save_Proceed: "NFO_Opt_Save_Proceed",
  NFO_Opt_Allocate_Other_Funds: "NFO_Opt_Allocate_Other_Funds",

  // North Star
  AppForm_OcupationalActivityHazard: "AppForm_Ocupational&ActivityHazard",
  AppForm_OcupationalActivityHazard_toggleOn: "AppForm_Ocupational&ActivityHazard_toggleOn",
  AppForm_OcupationalActivityHazard_Avocation_toggleOn: "AppForm_Ocupational&ActivityHazard_Avocation_toggleOn",
  AppForm_HabitsDetails: "AppForm_HabitsDetails",
  AppForm_HabitsDetails_Que_Yes: "AppForm_HabitsDetails_Que_Yes",
  KnowYourCharges_Selected: "KnowYourCharges_Selected",
  KnowYourCharges_PopUpOpen: "KnowYourCharges_PopUpOpen",
  KnowYourCharges_PopUpClose: "KnowYourCharges_PopUpClose",
  SwitchFund_Selected: "SwitchFund_Selected",
  SwitchFund_PopUpOpen: "SwitchFund_PopUpOpen",
  SwitchFund_PopUpClose: "SwitchFund_PopUpClose",
  SwitchFund_SeeCalculation: "SwitchFund_SeeCalculation",
});
